import React from "react";

export const MoreInfo = () => {
  return (
    <div className="w-full px-8 py-10 bg-slate-50 text-[#14141f]">
      <h2 className="text-2xl font-bold mb-6">
        Freelancer — pierwsze kroki (WeExpert)
      </h2>
      <h3 className="text-xl font-semibold mb-4">Spis tematów</h3>
      <ul className="list-disc pl-6 space-y-2">
  <li>
    <a href="#jak-zalozyc-konto" className="hover:underline">
      Jak założyć konto w WeExpert?
    </a>
  </li>
  <li>
    <a href="#freelancer-co-zyskuje" className="hover:underline">
      WeExpert dla freelancerów – co zyskuję?
    </a>
  </li>
  <li>
    <a href="#kto-moze-korzystac" className="hover:underline">
      Kto może korzystać z WeExpert jako freelancer?
    </a>
  </li>
  <li>
    <a href="#wlasna-firma" className="hover:underline">
      Czy mogę korzystać z WeExpert, jeśli mam własną firmę?
    </a>
  </li>
  <li>
    <a href="#faktura-vat" className="hover:underline">
      Komu mogę wystawić fakturę VAT w WeExpert?
    </a>
  </li>
  <li>
    <a href="#jakie-prace" className="hover:underline">
      Jakie prace można rozliczyć przez WeExpert?
    </a>
  </li>
  <li>
    <a href="#cennik-freelancer" className="hover:underline">
      Cennik dla freelancerów
    </a>
  </li>
  <li>
    <a href="#ile-faktur" className="hover:underline">
      Ile faktur można wystawić? Czy są limity umów?
    </a>
  </li>
  <li>
    <a href="#legalnosc" className="hover:underline">
      Czy WeExpert jest legalny?
    </a>
  </li>
  <li>
    <a href="#umowa-o-dzielo" className="hover:underline">
      Umowa o dzieło z WeExpert – на czym polega?
    </a>
  </li>
  <li>
    <a href="#umowa-zlecenie" className="hover:underline">
      Umowa zlecenia z WeExpert – на czym polega?
    </a>
  </li>
  <li>
    <a href="#customer-service" className="hover:underline">
      Jak działa Customer Service (Biuro Obsługi Klienta) i kontakt z WeExpert?
    </a>
  </li>
</ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak założyć konto w WeExpert?
      </h3>
      <p className="mb-4">
        Aby w pełni korzystać z funkcji WeExpert (wystawianie faktur,
        podpisywanie umów online), załóż konto freelancera.
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Czego potrzebujesz do założenia konta?
      </h4>

      <p className="font-medium mt-4 mb-2">
        Jeśli nie prowadzisz firmy, prosimy o:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>imię i nazwisko,</li>
        <li>
          PESEL (jeśli nie mieszkasz w Polsce – datę urodzenia i numer
          identyfikacji podatkowej w Twoim kraju),
        </li>
        <li>
          adres zamieszkania (jeśli mieszkasz w Polsce, na podstawie adresu
          wybierzesz właściwy urząd skarbowy),
        </li>
        <li>numer telefonu.</li>
      </ul>

      <p className="font-medium mt-4 mb-2">
        Jeśli prowadzisz działalność gospodarczą, poprosimy o:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>nazwę firmy,</li>
        <li>adres firmy,</li>
        <li>
          NIP (lub lokalny numer podatkowy firmy, jeśli mieszkasz poza Polską).
        </li>
      </ul>

      <p className="italic mt-4">
        Wskazówka: po wpisaniu kodu pocztowego wybierz miejscowość z listy.
        Jeśli Twojej miejscowości nie widać, wyczyść pliki cookies, użyj trybu
        incognito lub innej przeglądarki.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dlaczego prosimy o te dane?
      </h3>
      <p  className="mb-4">
        Ponieważ rozliczając klienta przez WeExpert, zawierasz umowę z WeExpert.
        Dane są potrzebne, by:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>legalnie pośredniczyć w Twojej transakcji,</li>
        <li>
          wystawić fakturę VAT Twojemu klientowi (bez zakładania firmy po Twojej
          stronie),
        </li>
        <li>odprowadzić należne podatki (jeśli dotyczą),</li>
        <li>skontaktować się z Tobą w sprawach rozliczeń.</li>
      </ul>
      <p className="italic">
        Dbamy o bezpieczeństwo — przetwarzamy dane zgodnie z RODO. Pytania?
        Napisz:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>{" "}
        (zajrzyj też do naszej Polityki prywatności).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Zakładanie konta — krok po kroku
      </h3>
      <ol className="list-decimal pl-6 space-y-2 mb-4">
        <li>Kliknij „Zaloguj się”, następnie „Załóż konto”.</li>
        <li>
          Podaj e-mail i hasło, przeczytaj i zaakceptuj Regulamin oraz Politykę
          prywatności.
        </li>
        <li>Kliknij link weryfikacyjny wysłany na Twój e-mail.</li>
        <li>
          Odpowiedz na krótkie pytania (dopasujemy komunikację i wsparcie).
        </li>
        <li>
          Uzupełnij dane osobowe i podatkowe (na ekranie przeprowadzimy Cię krok
          po kroku).
        </li>
        <li>
          Po zapisaniu danych rozpoczniemy weryfikację profilu (w tle). W tym
          czasie możesz już:
          <ul className="list-disc pl-6 mt-2">
            <li>wystawić fakturę (jeśli praca jest wykonana),</li>
          </ul>
        </li>
        <li>
          Dodaj kategorie i umiejętności — będziemy wysyłać powiadomienia o
          nowych zleceniach z Twoich kategorii.
        </li>
      </ol>
      <p className="mt-4">
        Gdy zakończymy weryfikację, dostaniesz e-mail. Od tego momentu masz
        nielimitowany dostęp do rozliczeń.
      </p>

      <h3 id='freelancer-co-zyskuje' className="text-xl font-semibold mt-10 mb-4">
        Mam konto — co dalej?
      </h3>
      <p className="mb-4">
        W naszym Centrum Pomocy znajdziesz instrukcje, m.in. jak:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>wystawić fakturę klientowi,</li>
        <li>zabezpieczyć płatność umową przed startem pracy,</li>
      </ul>

      <h3  className="text-xl font-semibold mb-4">
        WeExpert dla freelancerów — co zyskuję?
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Faktura VAT bez firmy i minimum formalności, z szybką wypłatą.</li>
        <li>
          Podpisanie umowy online – zabezpieczenie płatności przed startem pracy
          i bezpieczny transfer plików.
        </li>
        <li>WeExpert Jobs – dostęp do nowych zleceń i klientów.</li>
        <li>
          Zaproszenia do współpracy od zleceniodawców poszukujących
          specjalistów.
        </li>
      </ul>

      <h3 id='kto-moze-korzystac' className="text-xl font-semibold mb-4">
        „Jednorazowa Umowa” — gdy praca jest już wykonana
      </h3>
      <ol className="list-decimal pl-6 space-y-2 mb-4">
        <li>
          Wypełniasz formularz „Jednorazowa umowa” (dane klienta, opis pracy,
          załączasz pliki potwierdzające wykonanie).
        </li>
        <li>Wysyłamy klientowi pro formę.</li>
        <li>
          Klient opłaca pro formę online (tym samym potwierdza rozliczenie przez
          WeExpert).
        </li>
        <li>Wystawiamy klientowi fakturę VAT i przekazujemy mu Twoje pliki.</li>
        <li>
          Wypłacamy Tobie wynagrodzenie netto — zwykle do 24 h w dni robocze od
          zaksięgowania wpłaty.
        </li>
      </ol>

      <p className="mt-4">
        <span className="font-medium">Korzystaj, jeśli:</span> masz klienta,
        praca jest gotowa, posiadasz pliki potwierdzające wykonanie, a klient
        akceptuje rezultat.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Kto może korzystać z WeExpert jako freelancer?
      </h3>
      <p className="mb-4">
        Profil freelancera mogą założyć osoby fizyczne i firmy z Polski i z
        zagranicy. Nie musisz prowadzić działalności gospodarczej.
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Obywatele polscy mieszkający za granicą
      </h4>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>
          Jeśli Twoja rezydencja podatkowa jest poza Polską, podaj numer
          podatkowy kraju rezydencji.
        </li>
        <li>Nie pobierzemy podatku dochodowego w Polsce.</li>
        <li>
          Prześlij potwierdzenie rezydencji na{" "}
          <a href="mailto:info@weexpert.io" className="underline text-blue-500">
            info@weexpert.io
          </a>
          .
        </li>
        <li>Wymagana jest weryfikacja tożsamości (KYC).</li>
      </ul>

      <p className="mb-6">
        Ze względu na sankcje nie obsługujemy rozliczeń, jeśli mieszkasz w:
        Afganistanie, Białorusi, DR Konga, Erytrei, Gwinei, Haiti, Iranie,
        Iraku, Jemenie, Korei Płn., Kubie, Libanie, Libii, Mali, Mjanmie,
        Nikaragui, Sudanie Płd., RŚA, Rosji, Somalii, Sudanie, Syrii, Wenezueli,
        Zimbabwe oraz w regionach Ukrainy: Donieck, Ługańsk, Cherson, Zaporoże,
        Krym. <span className="italic">(Lista może się aktualizować.)</span>
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Obcokrajowcy mieszkający w Polsce
      </h4>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>
          <span className="font-medium">Obywatele UE:</span> podaj polski adres
          i PESEL (rozliczymy podatek w PL); wymagana weryfikacja tożsamości.
        </li>
        <li>
          <span className="font-medium">Obywatele spoza UE:</span> potrzebny
          dokument uprawniający do pracy/pobytu, np.:
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Karta Pobytu z adnotacją „dostęp do rynku pracy”,</li>
            <li>Karta pobytowa członka rodziny obywatela UE,</li>
            <li>wiza Poland Business Harbour / wiza D 21 (humanitarna),</li>
            <li>
              dokument PESEL dla uchodźców z Ukrainy po 24.02.2022 (ważny do
              30.09.2025),
            </li>
            <li>
              zaświadczenie o zarejestrowaniu pobytu (Brytyjczycy po
              30.12.2020),
            </li>
            <li>Karta Polaka,</li>
            <li>legitymacja/dyplom polskiej uczelni,</li>
            <li>akt małżeństwa z obywatelem/ką Polski,</li>
            <li>status uchodźcy.</li>
          </ul>
        </li>
      </ul>

      <p className="italic">
        Wyślij skan na{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        . Wymagana weryfikacja tożsamości.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Urlop macierzyński</h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Możesz rozliczać umowy o dzieło (nieoskładkowane) — zasiłek pozostaje
          bez zmian.
        </li>
        <li>
          Umowa zlecenia jest możliwa, jeśli Twój zasiłek brutto ≥ minimalne
          wynagrodzenie; odprowadzimy składkę zdrowotną.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mb-4">Urlop wychowawczy</h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Możesz rozliczać tylko umowę o dzieło (praca nie może uniemożliwiać
          opieki nad dzieckiem).
        </li>
        <li>
          Umowa zlecenia na wychowawczym — nie, bo utracisz prawo do
          ubezpieczenia społecznego.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mb-4">Zwolnienie lekarskie (L4)</h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>W czasie L4 nie rozliczasz się przez WeExpert.</li>
      </ul>

      <h3 className="text-xl font-semibold mb-4">
        Osoby zarejestrowane jako bezrobotne
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Konto możesz mieć, ale przed pierwszym rozliczeniem (gdy klient opłaci
          pro formę i powstanie umowa z WeExpert) musisz się wyrejestrować z PUP
          (masz na to 7 dni od opłacenia pro formy).
        </li>
      </ul>

      <h3 className="text-xl font-semibold mb-4">
        Osoby prowadzące działalność gospodarczą
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Możesz korzystać z WeExpert. Wystawiasz faktury na WeExpert (zaznacz
          „Konto firmowe” przy rejestracji).
        </li>
      </ul>

      <h3 id='wlasna-firma' className="text-xl font-semibold mb-4">
        Faktury na firmę małżonki(-a)
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Dozwolone tylko przy rozdzielności majątkowej.</li>
      </ul>

      <h3 id='faktura-vat' className="text-xl font-semibold mt-10 mb-4">
        Czy mogę korzystać z WeExpert, jeśli mam własną firmę?
      </h3>
      <p className="mb-6">
        Tak. Rejestrujesz konto firmowe i wystawiasz faktury na WeExpert zgodnie
        z wybranym trybem rozliczenia.
      </p>

      <h3 id='jakie-prace' className="text-xl font-semibold mt-10 mb-4">
        Komu mogę wystawić fakturę VAT w WeExpert?
      </h3>
      <p className="mb-6">
        Praktycznie każdemu klientowi: osobie prywatnej, firmie w Polsce, w UE
        (z VAT UE) i poza UE. W formularzu podajesz dane nabywcy — my wystawiamy
        fakturę VAT.
      </p>

      <h3 id='cennik-freelancer' className="text-xl font-semibold mt-10 mb-4">
        Jakie prace można rozliczyć przez WeExpert?
      </h3>
      <p className="mb-4">
        Większość usług realizowanych zdalnie: IT/Dev, UX/UI, grafika, DTP,
        wideo/audio, animacja, copywriting, tłumaczenia, marketing i reklama
        (SEO/SEM/SM), analityka, administracja, doradztwo, szkolenia online,
        wirtualna asysta i inne rezultaty niematerialne.
      </p>
      <p className="italic mb-6">
        Jeśli masz nietypowe zlecenie — napisz:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>

      <h3 id='ile-faktur' className="text-xl font-semibold mt-10 mb-4">
        Cennik dla freelancerów
      </h3>
      <p className="mb-6">
        Aktualne stawki opłat (prowizja serwisowa, usługi dodatkowe) publikujemy
        w Cenniku WeExpert. W razie pytań —{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>

      <h3  id='legalnosc' className="text-xl font-semibold mt-10 mb-4">
        Ile faktur można wystawić? Czy są limity umów?
      </h3>
      <p className="mb-6">
        Brak limitu liczby rozliczeń/umów — o ile transakcje są zgodne z prawem,
        Regulaminem i przejdą procedury bezpieczeństwa (KYC/AML). Zastrzegamy
        możliwość dodatkowej weryfikacji.
      </p>

      <h3 id='umowa-o-dzielo' className="text-xl font-semibold mt-10 mb-4">
        Czy WeExpert jest legalny?
      </h3>
      <p id='umowa-zlecenie'>
        Tak. Działamy zgodnie z prawem polskim i RODO, będąc pośrednikiem Twoich
        rozliczeń. Zawierasz umowę z WeExpert, a my wystawiamy fakturę VAT
        Twojemu klientowi i wypłacamy Twoje wynagrodzenie zgodnie z przepisami.
      </p>

      <h3  className="text-xl font-semibold mt-10 mb-4">
        Umowa o dzieło z WeExpert — na czym polega?
      </h3>
      <p className="mb-6">
        Stosowana, gdy rezultat ma charakter konkretny i indywidualny
        (utwór/dzieło). Nie podlega składkom ZUS. Podatek rozliczamy zgodnie z
        prawem; przy utworach możliwe 50% KUP (jeśli spełnione warunki).
      </p>

      <h3 id='customer-service' className="text-xl font-semibold mt-10 mb-4">
        Umowa zlecenia z WeExpert — na czym polega?
      </h3>
      <p className="mb-6">
        Stosowana, gdy przeważa czynność/usługa bez wyodrębnionego dzieła.
        Obejmuje odpowiednie obciążenia publicznoprawne (w tym składkę
        zdrowotną, gdy dotyczy).
      </p>

      <p>
        Dobór rodzaju umowy zależy od charakteru pracy. System wskaże właściwy
        tryb przy wypełnianiu formularza.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak działa Customer Service (BOK) i kontakt z WeExpert?
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          E-mail:{" "}
          <a href="mailto:info@weexpert.io" className="underline text-blue-500">
            info@weexpert.io
          </a>
        </li>
        <li>
          W wiadomości podaj: opis sprawy, dane konta, numer zlecenia/faktury
          (jeśli dotyczy).
        </li>
        <li>
          Obsługujemy także kwestie weryfikacji KYC, statusów płatności, faktur,
          sporów i bezpieczeństwa.
        </li>
      </ul>
      
      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak korzystać z WeExpert jako freelancer z firmą?
      </h3>
      <p className="mb-4">
        Po założeniu konta firmowego wystawiasz fakturę na WeExpert po każdym
        rozliczeniu z klientem:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>WeExpert wystawia fakturę Twojemu klientowi.</li>
        <li>
          Ty wystawiasz fakturę/rachunek dla WeExpert (nabywca: WeExpert).
        </li>
        <li>
          Po podpięciu swojej faktury w zakładce Umowy wypłacamy Twoje
          wynagrodzenie brutto (Ty rozliczasz podatek zgodnie z formą
          opodatkowania firmy).
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dlaczego warto rozliczać się przez WeExpert, mając firmę?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Bezpieczeństwo płatności. Przed startem pracy zabezpieczamy środki:
          wysyłamy klientowi pro formę.
        </li>
        <li>
          Faktura VAT dla klienta. Jeśli nie jesteś VAT-owcem, a klient wymaga
          faktury VAT — w WeExpert to możliwe (fakturę VAT wystawia WeExpert
          klientowi).
        </li>
        <li>
          Zagraniczni klienci. Rozliczasz zagranicę na takich samych zasadach
          jak Polskę. Wgrywasz fakturę na swoje konto, my wypłacamy
          wynagrodzenie.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy mogę rozliczyć się jako osoba fizyczna, jeśli mam firmę?
      </h3>
      <p className="mb-4">To zależy od PKD Twojej działalności.</p>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Nie możesz rozliczać jako osoba fizyczna usług, które wchodzą w PKD
          Twojej firmy (w WeExpert ani poza nim).
        </li>
        <li>Możesz rozliczać jako osoba fizyczna usługi spoza PKD firmy.</li>
      </ul>

      <h3 className="text-xl font-semibold mb-4">
        Czy mogę rozliczać się jako osoba fizyczna, gdy firma jest zawieszona?
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Nie rozliczysz jako osoba fizyczna usług wpisanych do PKD zawieszonej
          firmy — do tego służy konto firmowe.
        </li>
        <li>
          Jako osoba fizyczna możesz rozliczyć tylko usługi spoza PKD
          zawieszonej działalności.
        </li>
        <li>
          Prace z PKD rozliczysz jako osoba fizyczna dopiero po zamknięciu
          działalności.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Mam konto firmowe, ale zamknęłam(-ąłem) działalność
      </h3>
      <p className="mb-4">
        Poinformuj nas:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        . Zmienimy status prawny na „Nie reprezentuję ani nie prowadzę firmy” i
        Twoje konto stanie się kontem freelancera-osoby fizycznej.
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Po zmianie będziemy odprowadzać podatek dochodowy od Twoich rozliczeń
          do właściwego urzędu skarbowego.
        </li>
        <li>
          Statystyki (liczba umów/opinii) z dawnego konta firmowego nie
          przeniosą się.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Mam konto osoby fizycznej, ale otworzyłam(-em) działalność
      </h3>
      <p className="mb-4">
        Napisz do nas:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Po zmianie nie odprowadzamy za Ciebie podatku dochodowego od rozliczeń
          firmowych.
        </li>
        <li>Statystyki z konta osoby fizycznej nie przeniosą się.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak w firmie zaksięgować przychód z WeExpert?
      </h3>
      <p className="mb-6">
        Tak jak każdy inny przychód: wystaw swoją fakturę/rachunek na WeExpert i
        dodaj go do właściwej umowy w zakładce Umowy (poprosimy o to mailowo
        przed wypłatą). Wypłata brutto → dalej rozliczasz podatek według swojej
        formy.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Mam zlecenie z WeExpert Jobs — czy mogę samodzielnie wystawić fakturę
        zleceniodawcy?
      </h3>
      <p className="mb-6">
        Nie. Zlecenia pozyskane przez WeExpert Jobs muszą być rozliczane w
        ramach platformy (dotyczy także wykonawców z własną firmą). Naruszenie
        Regulaminu może skutkować blokadą konta.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Komu mogę wystawić fakturę VAT w WeExpert?
      </h3>
      <p className="mb-6">
        WeExpert umożliwia rozliczenia osoba-firma / firma-firma / osoba-osoba.
        Możesz korzystać z platformy jako osoba fizyczna lub firma i rozliczać
        się z osobami prywatnymi oraz firmami.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy w WeExpert mogę wystawić fakturę VAT dla osoby fizycznej?
      </h3>
      <p className="mb-6">
        Tak. Zleceniodawca nie musi mieć firmy, aby otrzymać fakturę VAT
        wystawioną przez WeExpert.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy w WeExpert mogę wystawić fakturę VAT dla firmy, która nie jest
        płatnikiem VAT?
      </h3>
      <p className="mb-6">
        Tak. WeExpert jest płatnikiem VAT, więc klient otrzyma fakturę VAT,
        nawet jeśli sam nie jest VAT-owcem. Dla podmiotów zwolnionych z VAT lub
        w przypadkach ustawowych wystawiamy faktury zwolnione albo 0%/reverse
        charge (zgodnie z przepisami).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy w WeExpert mogę wystawić fakturę klientowi z zagranicy?
      </h3>
      <p className="mb-4">
        Tak, z zastrzeżeniami sankcyjnymi. Nie rozliczamy klientów z:
        Afganistanu, Białorusi, DR Konga, Erytrei, Gwinei, Haiti, Iranu, Iraku,
        Jemenu, Korei Płn., Kuby, Libanu, Libii, Mali, Mjanmy, Nikaragui, Sudanu
        Płd., RŚA, Rosji, Somalii, Sudanu, Syrii, Wenezueli, Zimbabwe oraz
        regionów Ukrainy: Donieck, Ługańsk, Cherson, Zaporoże, Krym.{" "}
        <span className="italic">(Lista może się aktualizować.)</span>
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Klient zagraniczny – firma: co do zasady faktura bez VAT (reverse
          charge); podatek rozlicza nabywca w swoim kraju.
        </li>
        <li>
          Klient zagraniczny – osoba prywatna: faktura z polską stawką VAT.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jakie prace można rozliczyć przez WeExpert?
      </h3>
      <p className="mb-4">
        W WeExpert rozliczysz większość prac zdalnych oraz część prac
        biurowych/usług. Rozliczenie opiera się domyślnie o umowę o dzieło (a w
        uzasadnionych przypadkach – o umowę zlecenia).
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Umowa o dzieło – podstawa rozliczenia
      </h4>
      <p className="mb-4">
        Gdy wypełniasz formularz Jednorazowa umowa, zawierasz
        z WeExpert umowę o dzieło (online).
      </p>
      <ul className="list-disc pl-6 space-y-1 mt-10 mb-4">
        <li>
          WeExpert wystawia fakturę Twojemu klientowi i pobiera od niego
          płatność.
        </li>
        <li>Następnie wypłacamy Tobie wynagrodzenie.</li>
      </ul>
      <p className="mb-6">
        Ponieważ podstawą jest dzieło, praca musi mieć konkretny rezultat, który
        potwierdzisz plikiem (np. grafika, kod, dokument, nagranie).
      </p>

      <h4 className="text-lg font-semibold mb-2">Przykładowe dziedziny:</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>Serwisy internetowe: strony, sklepy, obsługa WWW.</li>
        <li>Multimedia: wideo, animacja, muzyka, fotografia.</li>
        <li>
          Programowanie/IT: aplikacje, oprogramowanie, wdrożenia,
          administrowanie serwerami.
        </li>
        <li>
          Marketing: kampanie, social media, copywriting, SEO, analityka,
          e-mailing, telemarketing.
        </li>
        <li>Design: grafika 2D/3D, architektura, UX/UI.</li>
        <li>Tłumaczenia.</li>
        <li>
          Prace biurowe: bazy danych, wirtualna asysta, wprowadzanie danych,
          obsługa klienta, wnioski, badania rynku, PM.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jakie prace na umowie zlecenia?
      </h3>
      <p className="mb-4">
        Jeśli spełniasz warunki, możesz rozliczyć umowę zlecenia (większy zakres
        czynności): np. nauczanie języków, obsługa klienta/sprzedaży, doradztwo,
        konsultacje, wygłoszenie prezentacji.
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>
          Przedmiotem zlecenia jest czynność, nie rezultat (np. „przedstawienie
          prezentacji”).
        </li>
        <li>
          Możesz rozdzielić: przygotowanie prezentacji (dzieło) + wygłoszenie
          (zlecenie).
        </li>
      </ul>
      <p className="mb-6">
        Zasady: umowy zlecenia rozliczamy z osobami którzy mieszkają poza Polską , ze studentami do 26 r.ż. oraz osobami
        zatrudnionymi (umowa zlecenia lub o pracę) z wynagrodzeniem ≥ minimalne
        wynagrodzenie. Skontaktuj się, jeśli masz wątpliwości:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Cennik dla freelancerów (WeExpert)
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>Opłata serwisowa: 5% od wartości umowy (PLN).</li>
        <li>Minimum od pojedynczego zlecenia: 65 zł.</li>
        <li>
          Maksimum miesięczne (limit): 499 zł. Po osiągnięciu limitu — kolejne
          rozliczenia w miesiącu są bez opłat serwisowych.
        </li>
        <li>
            Po przekroczeniu 10 000 $ (Opłata serwisowa nie będzie wliczane w limit) w bieżącym miesiącu pobieramy dodatkowo 3% z całej kwoty Umowy
        </li>
        <li>Funkcje takie jak WeExpert Jobs — darmowe.</li>
        <li>
          Dla rozliczeń w EUR/USD/GBP/CHF: 5%, min. 18 i max 135 EUR/USD/GBP.
        </li>
      </ul>
      <p className="mb-6">
        Aby policzyć koszt transakcji, skorzystaj z Kalkulatora WeExpert (albo
        napisz do nas:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        ).
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Jak działa limit opłaty serwisowej?
      </h4>
      <p className="mb-4">
        Sumujemy Twoje opłaty serwisowe w danym miesiącu i przypisujemy do konta
        freelancera. Po osiągnięciu 499 zł — reszta miesiąca bez opłat
        serwisowych. Opłatę odejmujemy po zaksięgowaniu płatności od klienta
        (decyduje data wpływu pro formy).
      </p>

      <h4 className="text-lg font-semibold mb-2">
        „Data umowy” i różne waluty
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          O przypisaniu do miesiąca decyduje data zaksięgowania pro formy u nas
          (np. wystawione 31.01, opłacone 03.02 → luty).
        </li>
        <li>
          Rozliczenia w różnych walutach przeliczamy proporcjonalnie i sumujemy.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Co wlicza się do limitu?
      </h3>
      <p className="mb-4">
        Wlicza się: opłaty serwisowe z Twoich prac (na podstawie kwoty na
        fakturze) z procesów Jednorazowa Umowa, oraz zleceń z
        WeExpert Jobs.
      </p>
      <p className="mb-6">
        Nie wlicza się: zaliczki na PIT, opłat operatora płatności online, opłat
        za usługi dodatkowe (np. wysyłka dokumentów), ani opłaty za ominięcie
        pro formy/wydłużenie terminu płatności.
      </p>

      <h3>
        Co wlicza się do limitu?
      </h3>
      <p>
        Wlicza się: Kwota netto do wypłaty,  zaliczki na PIT, opłata operatora płatności online, opłata za usługi dodatkowe (np. wysyłka dokumentów), opłaty za ominięcie pro formy/wydłużenie terminu płatności.
      </p>
      <p>
        Nie wlicza się: 
      </p>
      <p>
        opłaty serwisowe z Twoich prac (na podstawie kwoty na fakturze) z procesów Jednorazowa Umowa, Podpisz umowę oraz zleceń z WeExpert Jobs.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak liczymy opłatę w pojedynczej umowie?
      </h3>
      <p className="mb-6">
        Naliczamy od kwoty netto na fakturze (nie od „na rękę”). Stawka: 5%
        (PLN) lub 5% (EUR/USD/GBP/CHF) z min. 65 PLN / 9 EUR/USD/GBP i maks. do
        miesięcznego limitu (499 PLN lub 135 EUR/USD/GBP/CHF).
      </p>

      <h4 className="text-lg font-semibold mb-2">Inne opłaty (freelancer)</h4>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>Ekspresowa wypłata przelewem: 20 zł lub 10 EUR/USD/GBP.</li>
        <li>Wysyłka dokumentów pocztą: 50 zł lub 10 EUR/USD/GBP.</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2">
        Dodatkowe opłaty (zleceniodawca)
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>Wysyłka dokumentów pocztą: 50 zł lub 10 EUR/USD/GBP.</li>
        <li>
          Opcjonalna opłata operacyjna przy szybkiej płatności — zależna od
          kraju i waluty (pokrywa koszty obsługi i infrastruktury).
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Ile faktur można wystawić w WeExpert? Czy są limity umów?
      </h3>
      <p className="mb-4">
        Nie ma limitu liczby umów. Polskie prawo nie ogranicza liczby umów o
        dzieło ani zleceń, więc możesz wystawiać faktury w WeExpert dowolnie
        często i na dowolne kwoty.
      </p>
      <p className="mb-6">
        Nie wymagamy też minimalnej liczby umów w miesiącu.
      </p>

      <h4 className="text-lg font-semibold mb-2">Limit zarobków a WeExpert</h4>
      <p className="mb-6">
        Rozliczenia w WeExpert nie są działalnością nierejestrowaną — nie
        obowiązuje „limit zarobków” z tej instytucji i nie wymuszamy zakładania
        działalności gospodarczej tylko z powodu częstych rozliczeń.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy WeExpert jest legalny?
      </h3>
      <p className="mb-6">
        Tak. WeExpert działa zgodnie z prawem polskim. Zawieramy z freelancerami
        umowy cywilnoprawne (online), legalnie wystawiamy klientom faktury VAT i
        przekazujemy wynagrodzenie zgodnie z przepisami.
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Kto może legalnie rozliczać się w WeExpert?
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Osoby fizyczne bez firmy — możesz pracować jako freelancer(ka) bez
          zakładania działalności.
        </li>
        <li>
          Osoby prowadzące firmy (JDG, spółki) — zyskujesz gwarancję płatności i
          prosty proces rozliczeń.
        </li>
        <li>Możesz łączyć rozliczenia w WeExpert z etatem.</li>
        <li>
          Nieważne, gdzie mieszkasz i płacisz podatki — mamy ścieżki zarówno dla
          PL rezydentów, jak i zagranicy (z wyłączeniem krajów/regionów objętych
          sankcjami).
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Umowa między WeExpert a freelancerem
      </h3>
      <p className="mb-4">
        Standardowo zawieramy umowę o dzieło (przedmiot: rezultat). W
        uzasadnionych przypadkach — umowę zlecenia (odprowadzimy podatek i
        składkę zdrowotną, jak wymagają przepisy jeśli mieszkasz w Polsce).
      </p>
      <p className="mb-6">
        Warunki (zakres, termin, wynagrodzenie) określasz w formularzu
        Jednorazowa Umowa / Podpisz umowę.
      </p>

      <h4 className="text-lg font-semibold mb-2">Faktura VAT</h4>
      <p className="mb-4">
        Po wypełnieniu formularza wysyłamy klientowi pro formę. Po jej
        opłaceniu:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Klient otrzymuje fakturę VAT.</li>
        <li>Ty otrzymujesz wypłatę (zgodnie z rodzajem konta).</li>
        <li>
          Pliki potwierdzające wykonanie pracy są bezpiecznie przekazywane.
        </li>
      </ul>

      <h4 className="text-lg font-semibold mb-2">Podatek dochodowy</h4>
      <p className="mb-6">
        Dla freelancerów z polską rezydencją podatkową WeExpert odprowadza
        podatek dochodowy od umów cywilnoprawnych i co roku wysyła PIT-11 (do
        końca lutego — na e-mail z profilu).
      </p>

      <h4 className="text-lg font-semibold mb-2">ZUS</h4>
      <p className="mb-4">
        Wszystkie umowy z polskimi freelancerami zgłaszamy do ZUS:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Umowa o dzieło — bez składek ZUS.</li>
        <li>
          Umowa zlecenia — odprowadzamy składkę zdrowotną (zgodnie z prawem).
        </li>
      </ul>

      <h4 className="text-lg font-semibold mb-2">
        Ile umów można legalnie rozliczyć? Czy jest limit zarobków?
      </h4>
      <p className="mb-6">
        Nie ma limitu liczby umów o dzieło/zlecenia — możesz rozliczać się przez
        WeExpert bez limitu i bez obowiązku zakładania działalności gospodarczej
        wyłącznie z tego powodu.
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Umowa o dzieło z WeExpert – na czym to polega?
      </h4>
      <p className="mb-4">
        Kiedy rozliczasz się z klientem przez naszą platformę, nawiązujesz z
        WeExpert umowę o dzieło. Poniżej wyjaśniamy, jak to działa w świetle
        polskiego prawa i co to oznacza dla freelancera.
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Kiedy WeExpert zawiera umowę o dzieło z freelancerem?
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>Wypełniasz formularz Jednorazowa umowa.</li>
        <li>
          WeExpert wysyła Twojemu klientowi mail z fakturą pro forma i linkiem
          do płatności.
        </li>
        <li>
          Klient opłaca pro formę. W tym momencie dochodzi do zawarcia umowy o
          dzieło między Tobą a WeExpert — dla konkretnej pracy, którą wykonujesz
          dla klienta.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Umowa o dzieło online
      </h3>
      <p className="mb-4">
        Kodeks cywilny dopuszcza dowolną formę umowy o dzieło (ustnie, e-mailem,
        elektronicznie, papierowo). Dlatego w WeExpert uprościliśmy formalności
        — umowa w formie elektronicznej jest tak samo wiążąca jak papierowa.
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Szczegóły Twojej umowy o dzieło w WeExpert
      </h4>
      <p className="mb-4">
        W formularzu (Wystaw fakturę / Podpisz umowę / oferta w WeExpert Jobs)
        podajesz:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Zakres prac i rezultat.</li>
        <li>Termin wykonania.</li>
        <li>Stawki.</li>
      </ul>
      <p className="mb-6">Na tej podstawie powstaje umowa o dzieło.</p>

      <h4 className="text-lg font-semibold mb-2">
        Potwierdzenie wykonania umowy
      </h4>
      <p className="mb-4">
        Po zakończeniu rozliczenia (wypłacie wynagrodzenia) wyślemy Ci
        potwierdzenie wykonania umowy o dzieło. Na potrzeby banków/urzędów
        możemy przygotować zestawienie wszystkich umów cywilnoprawnych zawartych
        z WeExpert — napisz na{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>
      <p>
        <strong>Uwaga:</strong> w niektórych przypadkach podstawą rozliczenia
        jest umowa zlecenia (sprawdź: kiedy WeExpert zawiera umowy zlecenia).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Ile umów o dzieło zawierasz z WeExpert?
      </h3>
      <p className="mb-6">Każde rozliczenie = osobna umowa o dzieło.</p>

      <h4 className="text-lg font-semibold mb-2">
        Zgłaszanie umów o dzieło do ZUS
      </h4>
      <p className="mb-6">
        Każdą umowę o dzieło zawartą z polskim freelancerem zgłaszamy do ZUS.
        Pamiętaj o tym, jeśli planujesz L4 lub chcesz się zarejestrować w
        urzędzie pracy.
      </p>

      <h4 className="text-lg font-semibold mb-2">
        Customer Service (Biuro Obsługi Klienta) i kontakt
      </h4>
      <p className="mb-2">
        Jesteśmy do Twojej dyspozycji od poniedziałku do piątku.
      </p>
      <p>
        • Napisz:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        . Chętnie pomożemy i odpowiemy na Twoje pytania!
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Moje konto</h3>

      <h4 className="text-lg font-semibold mb-2">
        Jak uzupełnić lub edytować dane w profilu freelancera?
      </h4>
      <p className="mb-4">
        Zaloguj się → Lewy górny róg. Masz następujące sekcje:
      </p>
      <ol className="list-decimal pl-6 space-y-1 mb-6">
        
        <li>
          Umowy jednorazowe – tu sa możesz dodać nowego kontrahenta lub zobaczyć aktualnych. możesz sprawdzić swoje umowy z klientami, pliki i pobrać faktury. znajdziesznajdziesz swoje umowy, ich rodzaj i system podatkowy Można zobaczyć wyświetlane Pro-formy i ich status
        </li>
        <li>
          Moje Dokumenty – Tu wypełnisz i sprawdzisz: Główne informacje, Profil
          freelancera, Kwestionariusz i Moje dokumenty.
        </li>
        <li>Telegram BOT – Znajdziesz zlecenia w WeExpert Jobs.</li>
      </ol>
      <p className="mb-4">
        <strong>Uwaga:</strong> zmiany adresu e-mail, obywatelstwa, kraju
        zamieszkania, statusu prawnego (czy prowadzisz firmę) — prosimy o
        kontakt na{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>

      <h4 className="text-lg font-semibold mb-2">Dodawanie NIP-u</h4>
      <p>
        W profilu nie ma pola NIP.
        Chcesz zmienić status ? Napisz:
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dodawanie miejscowości przy zakładaniu konta
      </h3>
      <p className="mb-4">
        Jeśli po wpisaniu kodu pocztowego lista miejscowości się nie pojawi, spróbuj:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>Trybu incognito.</li>
        <li>Innej przeglądarki.</li>
        <li>Wyczyszczenia cookies.</li>
      </ul>
      <p className="mb-6">
        Dalej nie działa? Napisz:{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dodawanie tagów (umiejętności) i kategorii
      </h3>
      <p className="mb-6">
        Aby dodać/edytować: Pulpit → Moje Dokumenty → Profil Freelancera. Jeśli
        brakuje potrzebnego tagu — daj znać na{" "}
        <a href="mailto:info@weexpert.io" className="underline text-blue-500">
          info@weexpert.io
        </a>
        .
      </p>

      <h3 className="text-xl font-semibold mb-4">
        Czy mogę założyć nowe konto?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Możesz mieć tylko jedno konto osobiste (dla poprawnego rozliczania
          umów).
        </li>
        <li>
          Próba rejestracji z tym samym PESEL lub e-mailem zostanie zablokowana.
        </li>
        <li>
          Chcesz zmienić e-mail przypisany do konta? Napisz:{" "}
          <a href="mailto:info@weexpert.io" className="underline text-blue-500">
            info@weexpert.io
          </a>
          .
        </li>
        <li>
          Masz już konto firmowe? Możesz dodatkowo posiadać konto osobiste
          (statystyki — liczba umów/opinii — nie przenoszą się między kontami).
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Weryfikacja tożsamości
      </h3>

      <h4 className="text-lg font-medium mb-2">Co to jest?</h4>
      <p className="mb-4">
        Proces potwierdzenia, że jesteś tym, za kogo się podajesz — konieczny,
        aby bezpiecznie rozliczać się przez WeExpert i przeciwdziałać
        nadużyciom/AML. Zweryfikowane konto budzi większe zaufanie klientów.
      </p>
      <p className="mb-4">
        Weryfikacja odbywa się za pomocą zewnętrznej aplikacji (prezentujesz
        dokument i twarz do kamery). Zwykle zajmuje ok. 10 minut. Dane
        przetwarza i przechowuje wyspecjalizowany, zaufany dostawca.
      </p>

      <h4 className="text-lg font-medium mb-2">Kto musi się zweryfikować?</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Odprowadzają podatki poza Polską.</li>
        <li>Są obywatelami innego kraju niż Polska.</li>
        <li>
          Zmieniają imię i/lub nazwisko po wcześniejszej pozytywnej weryfikacji.
        </li>
      </ul>

      <h4 className="text-lg font-medium mb-2">Co przygotować?</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Ważny dokument ze zdjęciem (dowód / prawo jazdy / paszport).</li>
        <li>Telefon z aparatem lub komputer z kamerą.</li>
      </ul>

      <h4 className="text-lg font-medium mb-2">Jak wykonać weryfikację?</h4>
      <p className="mb-6">
        Dostaniesz plik do weryfikacji na maila  .  
      </p>

      <h4 className="text-lg font-medium mb-2">
        Co jeśli nie wykonam weryfikacji?
      </h4>
      <p className="mb-6">
        Możesz korzystać z serwisu, ale umowy i faktury nie wyślą się
        automatycznie — obsłużymy Twoje rozliczenie ręcznie (dłużej). Po
        pozytywnej weryfikacji wysyłka jest automatyczna i pieniądze trafiają
        szybciej.
      </p>

      <h4 className="text-lg font-medium mb-2">Niepowodzenie weryfikacji</h4>
      <p className="mb-6">
        Skontaktujemy się z Tobą i pomożemy ustalić przyczynę, aby zakończyć
        proces pomyślnie.
      </p>

      <h4 className="text-lg font-medium mb-2">Ważność</h4>
      <p className="mb-6">
        Weryfikacja jest z terminem na Rok, lub jesłi zmienisz dane osobowe — wtedy trzeba ją powtórzyć.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Konto freelancera – rozwiązywanie problemów
      </h3>

      <h4 className="text-lg font-medium mb-2">Nie mogę się zalogować</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>
          Sprawdź, czy używasz właściwego adresu e-mail (bez spacji przed/po).
        </li>
        <li>
          Jeśli nie aktywowałaś(-eś) konta, kliknij „Nie pamiętasz hasła?” —
          wyślemy nowy link i poprowadzimy dalej.
        </li>
        <li>
          Sprawdź, czy nie ma maila o naruszeniu Regulaminu i blokadzie (także w
          spamie).
        </li>
      </ul>

      <h4 className="text-lg font-medium mb-2">
        Moje konto zostało zablokowane
      </h4>
      <p className="mb-4">
        Najczęściej przy naruszeniu Regulaminu WeExpert. Zawsze wysyłamy mail z
        powodem blokady — sprawdź skrzynkę/spam.
      </p>

      <h4 className="text-lg font-medium mb-2">
        Nie dostaję maili od WeExpert
      </h4>
      <p className="mb-6">
        Sprawdź spam. Jeśli brak wiadomości, skontaktuj się ze swoim dostawcą
        poczty i poproś o dodanie domeny <code>weexpert.io</code> do listy
        wyjątków (dozwolonych nadawców).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Nie mam maila z linkiem aktywacyjnym
      </h3>
      <p className="mb-4">
        Na ekranie kliknij „Wyślij nowy link”.
 W razie potrzeby poproś dostawcę poczty o whitelisting domeny weexpert.i
      </p>
      <p className="mb-6">
        W razie potrzeby poproś dostawcę poczty o whitelisting domeny{" "}
        <code>weexpert.io</code>.
      </p>

      <h3 className="text-xl font-semibold mb-4">Jak usunąć konto?</h3>
      <p className="mb-6">
        Samodzielne usunięcie nie jest dostępne. Napisz do nas:{" "}
        <code>info@weexpert.io</code> — zajmiemy się tym.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dostępne typy rozliczeń w WeExpert
      </h3>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>
          <strong>Jednorazowa umowa</strong> – użyj, gdy praca jest już wykonana
          i chcesz wystawić klientowi fakturę VAT przez WeExpert (klient nie
          potrzebuje konta, formalności są minimalne).
        </li>
      </ul>

      <p className="mb-6">
        Szukasz zleceń? Sprawdź <strong>WeExpert Jobs</strong>.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Formularz „Jednorazowa umowa” – krok po kroku
      </h3>

      <ol className="list-decimal pl-6 space-y-4">
        <li>
          <strong>Dane klienta</strong>
          <br />
          Podaj adres e-mail klienta (kontakt prowadzimy mailowo).
          <br />
          <ul className="list-disc pl-6 space-y-1">
            <li>Osoba fizyczna (PL lub zagranica): imię, nazwisko, adres.</li>
            <li>Firma PL: NIP (pozostałe dane uzupełnią się automatycznie).</li>
            <li>
              Firma zagraniczna: numer podatkowy (odpowiednik NIP), nazwa i
              adres.
            </li>
          </ul>
        </li>

        <li>
          <strong>Kategoria pracy</strong>
          <br />
          Wybierz kategorię (np. Marketing → Social media). Trafi ona na fakturę
          VAT.
        </li>

        <li>
          <strong>Szczegóły pracy</strong>
          <br />
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Tytuł (trafi na fakturę i pomoże Ci znaleźć umowę na Pulpicie),
              np.: „Przebudowa strony produktowej w PrestaShop; 10 maili do
              newslettera (beauty)”.
            </li>
            <li>Opis – możliwie dokładny zakres/efekty/wymagania.</li>
            <li>(Opcjonalnie) Wiadomość do klienta – pokażemy ją w mailu.</li>
          </ul>
        </li>

        <li>
          <strong>Wysokość wynagrodzenia</strong>
          <br />
          <ul className="list-disc pl-6 space-y-1">
            <li>
              przełącz na „ Klient zapłaci” – wyliczymy Twoją wypłatę od kwoty na fakturze
            </li>
            <li>
              Uzupełnij “Klient zapłaci netto” -  wyliczymy kwotę  “na rękę” i kwotę do zapłaty Brutto
            </li>
          </ul>
        </li>

        <li>
          <strong>Prawa autorskie</strong>
          <br />
          Wybierz sposób rozporządzania prawami (wpływa na wynagrodzenie):
          <ul className="list-disc pl-6 space-y-1">
            <li>Prawa autorskie (całość majątkowych),</li>
            <li>Brak przeniesienia praw autorskich</li>
          </ul>
        </li>

        <li>
          <strong>Termin płatności</strong>
          <br />
          Klient ma tyle dni na opłacenie proformy, ile wskażesz. Poinformujemy
          go mailowo.
        </li>

        <li>
          <strong>Podsumowanie</strong>
          <br />
          Sprawdź wszystkie dane i zatwierdź wysyłkę propozycji umowy do
          klienta.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mb-4">
        Co dzieje się po wysłaniu formularza?
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
       <li>Klient otrzymuje fakturę pro forma na adres e-mail (jeśli został podany), lub można ją pobrać, klikając w wybraną umowę, aby wysłać ją samodzielnie.</li>
       <li>Po zaksięgowaniu płatności w zakładce „Jednorazowe umowy” pojawi się wezwanie do działania – Wyślij wniosek o wypłatę środków.</li>
       <li>Po kliknięciu w ten wniosek otrzymasz na e-mail dokumenty niezbędne do podpisania za pośrednictwem Autenti (kwalifikowany podpis elektroniczny).</li>
       <li>W zależności od rodzaju przeniesienia praw autorskich oraz typu umowy, liczba dokumentów do podpisania może się różnić.</li>
       <li>Po podpisaniu dokumentów z Twojej strony uruchomiony zostanie proces wypłaty środków na wskazane przez Ciebie konto (sprawdź zakładkę Moje dokumenty).</li>
       <li> Zazwyczaj wypłata środków następuje tego samego dnia — dla walut obcych (EUR, USD itp.) przelew wychodzi z banku do godziny 14:00 CET, dla PLN — do godziny 16:00 CET.<br></br> <b>W wyjątkowych przypadkach wypłata może potrwać do 24 godzin w dni robocze.</b></li>
      </ol>
      
      <h3 className="text-xl font-semibold  mt-10 mb-4">
        Rozliczenia z klientem zagranicznym
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Między WeExpert a freelancerem powstaje umowa o dzieło lub zlecenie.
        </li>
        <li>
          Za polskich rezydentów podatkowych odprowadzamy podatek dochodowy.
        </li>
        <li>Wypłacamy środki na wskazane konto/walutę.</li>
      </ul>
      <p>
        Faktury dla firm zagranicznych wystawiamy ze stawką VAT 0% / reverse
        charge (kwota brutto = netto); podatek VAT rozlicza klient w swoim
        kraju.
      </p>

      <h3 className="text-xl font-semibold mt-10  mb-4">
        Jak rozliczyć się z klientem zagranicznym?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Skorzystaj z <strong>Jednorazowa Umowa</strong>.
        </li>
        <li>
          Podaj e-mail klienta i (dla firmy) numer podatkowy (odpowiednik NIP).
        </li>
        <li>
          Gdy prześlemy proformę do wglądu, sprawdź kwotę i brak VAT, jeśli to
          firma zagraniczna.
        </li>
      </ul>

      <h3 className="text-xl font-semibold  mt-10 mb-4">Język faktury</h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Podpisz umowę: wybierzesz język faktury na etapie pobierania pro-formy.
        </li>
      </ul>

      <h3 className="text-xl font-semibold  mt-10 mb-4">Waluty</h3>
      <p>
        Obsługujemy: PLN, EUR, GBP, USD, CHF, CAD. Walutę wybierasz w formularzu przy cenie.
      </p>

      <h3 className="text-xl font-semibold mb-4">Wypłaty w obcych walutach</h3>
      <p>
        Ustaw metody wypłat w{" "}
        <strong>Pulpit → Moje Dokumenty → Główne Informacje</strong> dla
        PLN/EUR/GBP/USD/CHF, aby otrzymywać środki w danej walucie.
      </p>

      <h3 className="text-xl font-semibold mt-10  mb-4">
        Ograniczenia (sankcje/prawo)
      </h3>
      <p>
        Nie wystawiamy faktur klientom z/na: Afganistan, Białoruś, DR Konga,
        Erytrea, Gwinea, Haiti, Iran, Irak, Jemen, Korea Płn., Kuba, Liban,
        Libia, Mali, Mjanma (Birma), Nikaragua, Sudan Płd., RCA, Rosja, Somalia,
        Sudan, Syria, Wenezuela, Zimbabwe oraz regiony Ukrainy: Donieck,
        Ługańsk, Cherson, Zaporoże, Krym. Lista jest aktualizowana na bieżąco.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Weryfikacja umowy – jak długo to trwa?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Automatyczna – działa codziennie; jeśli przejdzie, proforma idzie do
          klienta.
        </li>
        <li>
          Ręczna (Customer Service) – gdy umowa nie spełniła warunków automatu;
          pracujemy pn–pt, 8:00–17:00.
        </li>
      </ul>
      <p>
        Wypełnienie po 17:00 i brak akceptu w automacie → zwykle weryfikujemy
        następnego dnia do 17:00. Czekasz dłużej? Sprawdź skrzynkę (i spam) —
        skontaktujemy się, jeśli potrzebne są dodatkowe informacje/dokumenty.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak przyspieszyć weryfikację?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
         Tytuł: używaj Latyńskich znaków, bez dat/miesięcy, nazwij dzieło (np. „Grafika…”, nie „zlecenie/faktura/rozliczenie”).
        </li>
        <li>
          Opis: przy umowie o dzieło nie podawaj godzin ani stawek godzinowych
          (to może kwalifikować do zlecenia).
        </li>
        <li>
          Plik: dodaj ukończone dzieło lub wiarygodny dowód wykonania spójny z
          tytułem/opisem/kwotą.
        </li>
        <li>Prawa autorskie: wybierz właściwy tryb (Brak/przeniesienie).</li>
      </ul>
      <p>
        Każde rozliczenie weryfikujemy także przy wypłacie — jeśli coś będzie
        niejasne, odezwiemy się.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Kody rabatowe</h3>
      <p>
        Kody rabatowe obniżają opłatę serwisową (np. o 5%, 20%, 50%). Dotyczą
        kont freelancera. Każdy kod użyjesz raz.
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Jak dostać kod? Na wydarzeniach, których partnerem jest WeExpert, i
          przy specjalnych akcjach (dla nowych i stałych użytkowników).
          Polecenie WeExpert nie generuje kodu.
        </li>
        <li>
          Gdzie wpisać? W <strong>Umowa jednorazowa</strong> - Podaj Kod
          (rozwijane menu pod kalkulatorem).
        </li>
        <li>
          Do kiedy ważny? Zależy od kodu (zawsze podajemy termin ważności).
        </li>
      </ul>
      <p>
        Potrzebujesz wsparcia? Napisz na <strong>info@weexpert.io</strong>.
      </p>

      <h3 className="text-xl font-semibold mb-4">
        Elektroniczne potwierdzenie zawarcia umowy – na czym polega?
      </h3>
      <p>
        Zawsze zawieramy z Tobą umowę cywilnoprawną (zwykle o dzieło; czasem
        zlecenia) — na jej podstawie odprowadzamy podatki (dla polskich
        rezydentów) i raz w roku wysyłamy PIT-11.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dlaczego moja umowa została zamknięta?
      </h3>
      <p>Zamykamy umowy, gdy:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Poprosi o to freelancer lub zleceniodawca (mail/telefon).</li>
        <li>Zwracamy się o doprecyzowanie i nie otrzymujemy odpowiedzi.</li>
        <li>
          Prosimy o korektę danych do faktury/dokumenty dot. zlecenia i brak
          odpowiedzi.
        </li>
        <li>Mamy uzasadnione podejrzenie niezgodności z prawem.</li>
      </ul>
      <p>
        Chcesz poznać szczegóły? Napisz na{" "}
        <a href="mailto:info@weexpert.io" className="text-blue-500 underline">
          info@weexpert.io
        </a>
        .
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Współpraca z obecnym lub byłym pracodawcą
      </h3>
      <p className="mb-4">
        Poniżej zasady, kiedy rozliczenie przez WeExpert jest możliwe.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Współpraca z obecną firmą
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Umowa o pracę:</strong> Nie rozliczysz przez WeExpert —
          dodatkowe zadania muszą być w ramach stosunku pracy lub w dodatkowej
          umowie cywilnoprawnej zawartej z pracodawcą. Przy jednoczesnej UoP +
          umowie cywilnoprawnej pobierane są składki ZUS z obu.
        </li>
        <li>
          <strong>Umowa o dzieło:</strong> Możesz rozliczyć przez WeExpert inną
          pracę niż ta na dotychczasowej UoD. Obie umowy bez ZUS, pobrana będzie
          zaliczka na PIT.
        </li>
        <li>
          <strong>Umowa zlecenia:</strong> Możesz rozliczyć przez WeExpert inną
          pracę niż ta na dotychczasowej UoZ.
        </li>
        <li>
          <strong>Prowadzisz działalność (B2B):</strong> Możesz rozliczać z tym
          samym klientem przez WeExpert jako osoba fizyczna tylko za inne usługi
          niż wpisane w PKD Twojej firmy. Zachowaj ostrożność przy zbliżonych
          PKD — urząd może to podważyć.
        </li>
        <li>
          <strong>Czy trzeba zrywać obecną UoD z klientem?</strong> Nie — jeśli
          chcecie mieć jedną umowę (o dzieło) i zmienić tylko sposób
          rozliczenia, dodajcie w części wynagrodzenia zapis, że rozliczenie
          odbywa się przez WeExpert.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Współpraca z byłą firmą
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Była UoP:</strong> Możecie rozliczyć przez WeExpert, jeśli
          praca jest inna niż ta na UoP. Gdy praca jest taka sama — nie
          (wyjątek: poprzednia firma została zamknięta).
        </li>
        <li>
          <strong>Była UoZ:</strong> Możecie rozliczyć przez WeExpert. Jeśli
          praca jest taka sama, z freelancerem zawrzemy umowę zlecenia (nie o
          dzieło).
        </li>
        <li>
          <strong>Była UoD:</strong> Możecie rozliczyć przez WeExpert. Jeśli
          praca jest taka sama, zawrzemy umowę o dzieło (nie zlecenie).
        </li>
        <li>
          Czas, jaki minął od zakończenia poprzednich umów, nie wpływa na
          powyższe zasady.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Co oznaczają statusy umów w WeExpert?
      </h3>
      <p className="mb-4">
        Każda Twoja umowa (rozliczenie) ma status informujący o etapie procesu.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Statusy umów – Jednorazowa Umowa
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li><span className="font-semibold">Oczekuje na zatwierdzenie</span> - Pierwszy status po utworzeniu umowy. Z tego etapu umowa może przejść do jednego z dwóch statusów:</li>
        <li><span className="font-semibold">Oczekuje na płatność</span> – jeśli umowa została zaakceptowana i generowana jest faktura pro forma,</li>
        <li><span className="font-semibold">Oczekuje na zmiany</span> – jeśli konieczna jest korekta treści umowy.  Na tym etapie system automatycznie generuje fakturę pro forma.</li>
        <li><span className="font-semibold">Oczekuje na płatność</span> - Umowa oczekuje na opłacenie faktury pro forma przez klienta.</li>
        <li>Po zaksięgowaniu wpłaty status zmienia się na: <span className="font-semibold">Oczekuje na wniosek o wypłatę</span></li>
        <li><span className="font-semibold">Oczekuje na wniosek o wypłatę</span> - Po otrzymaniu płatności użytkownik widzi wezwanie do działania „Wyślij wniosek o wypłatę środków”, czyli prośbę o przygotowanie dokumentów do podpisu. Po wysłaniu wniosku system zmienia status na: Użytkownik gotowy do podpisu (READY_FOR_SIGNATURE)</li>
        <li><span className="font-semibold">Użytkownik gotowy do podpisu</span> - W tym momencie zespół wysyła dokumenty do podpisania poprzez platformę Autenti (kwalifikowany podpis elektroniczny). Po wysłaniu dokumentów status zmienia się na: Oczekuje na podpis</li>
        <li><span className="font-semibold">Oczekuje na podpis</span> - Trwa proces podpisywania dokumentów przez wszystkie strony. Gdy wszystkie podpisy zostaną złożone, status zmienia się na: Rozpoczęto proces wypłaty</li>
        <li><span className="font-semibold">Rozpoczęto proces wypłaty</span> - Wszystkie dokumenty zostały podpisane, a asystent wprowadza wypłatę do systemu. Po zleceniu przelewu status zmienia się na końcowy:</li>
        <li><span className="font-semibold">Pieniądze wysłane</span></li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak sprawdzić status umowy?
      </h3>
      <p className="mb-4">
        Po zalogowaniu do WeExpert statusy znajdziesz na Pulpicie (bieżące) i w
        Jednorazowa Umowy (po tygodniu od wypłaty trafiają do tej sekcji).
        Status widnieje przy nazwie umowy.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        „Jednorazowa Umowa” – krok po kroku
      </h3>
      <ol className="list-decimal pl-6 space-y-4">
        <li>
          <strong>Podaj Szczegóły umowy:</strong> Jeśli to pierwsza transakcja u
          nas, uzupełnij:
          <ul className="list-disc pl-6 space-y-1">
            <li>Osoba fizyczna (PL/zagranica): imię, nazwisko, adres</li>
            <li>Firma PL: NIP (reszta danych uzupełni się automatycznie)</li>
            <li>
              Firma zagraniczna: numer podatkowy (odpowiednik NIP), nazwa i
              adres
            </li>
          </ul>
        </li>
        <li>
          <strong>Szczegóły pracy:</strong>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Kategoria, tytuł (trafi na fakturę) i opis (efekty prac – nie
              trafia na fakturę)
            </li>
            <li>
              Przykład 1:
              <ul className="list-disc pl-6 space-y-1">
                <li>Kategoria usług: Programowanie, IT</li>
                <li>Podkategoria: Aplikacje</li>
                <li>Tytuł umowy</li>
                <li>Wiadomość dla kontrahenta (opcjonalne)</li>
                <li>Opis umowy: 10 str. unikalnego kodu</li>
              </ul>
            </li>
            <li>
              Przykład 2:
              <ul className="list-disc pl-6 space-y-1">
                <li>Kategoria: Strony internetowe</li>
                <li>Tytuł: Przebudowa strony produktowej w Allegro</li>
                <li>
                  Opis: Odświeżony produkt page [adres], zmiany: [lista],
                  technologie: [tech]
                </li>
              </ul>
            </li>
            <li>Kategoria/tytuł/opis muszą być spójne z plikami</li>
          </ul>
        </li>
        <li>
          <strong>Cena:</strong>
          <ul className="list-disc pl-6 space-y-1">
            <li>
             Wpisz „Brutto”(twój klient zapłaci) – wyliczymy Twoją wypłatę od kwoty 
            </li>
            <li>
              Rodzaj przeniesienia praw autorskich (wpływ na wynagrodzenie):
              <ul className="list-disc pl-6 space-y-1">

                <li>Przenoszę prawa autorskie (całość majątkowych)</li>
                <li>Brak (zachowujesz prawa).</li>
              </ul>
            </li>
            <li>
              Termin opłacenia proformy – tyle dni damy klientowi na płatność
              (umowy weryfikujemy w dni robocze 8–17)
            </li>
          </ul>
        </li>
        <li>
          <strong>Dodawanie plików:</strong> Wgraj ukończone dzieło lub dowód
          ukończenia (np. zrzuty ekranu, raport, protokół, część projektu).
          Limit: do 5 plików, łącznie do 16MB. Jakie pliki dodać? Zależnie od
          branży – ważna jest spójność z tytułem/opisem/kwotą.
        </li>
        <li>
          <strong>Podsumowanie:</strong> Sprawdź dane i wyślij. Zweryfikujemy
          formularz i wyślemy klientowi proformę. Statusy i kolejne kroki
          będziemy wysyłać e-mailem. Po płatności klient otrzyma fakturę VAT, a
          Ty wynagrodzenie (w dni robocze zwykle ~24 h od akceptacji).
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak zgłosić nadużycie ze strony zleceniodawcy?
      </h3>
      <p className="mb-4">
        Napisz na{" "}
        <strong className="text-blue-500 underline">info@weexpert.io</strong>{" "}
        (temat: „Nadużycie – [ID umowy / link]”).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Co robimy po zgłoszeniu?
      </h3>
      <p className="mb-4">
        Każde zgłoszenie analizuje zespół Customer Service i proponuje
        rozwiązanie (np. mediacje, ostrzeżenie, czasowa/stała blokada konta) –
        indywidualnie do sprawy. O postępach informujemy zgłaszającego.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak uniknąć nadużyć – zasady korzystania z WeExpert
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Przeczytaj uważnie Regulamin. Masz wątpliwości? Pisz na{" "}
          <strong className="text-blue-500 underline">info@weexpert.io</strong>.
        </li>
        <li>Zachowuj kulturalną komunikację (bez wulgaryzmów, gróźb).</li>
        <li>
          Czytaj dokładnie maile i informacje w serwisie (rozumiej skutki
          kliknięć/akceptacji).
        </li>
        <li>
          Personalizuj oferty – masowe identyczne wiadomości mogą zostać uznane
          za spam (ryzyko blokady).
        </li>
        <li>
          Prowadź korespondencję w WeExpert – nie przenoś rozmowy poza serwis.
        </li>
        <li>
          Nie udostępniaj danych osobowych/kontaktowych w wiadomościach
          prywatnych.
        </li>
        <li>
          Nie wysyłaj plików z pracą bez umowy w WeExpert – podążaj za krokami w
          mailach i w panelu.
        </li>
      </ul>

      <p className="mb-4">
        Nie masz teraz zlecenia? Zajrzyj do <strong>WeExpert Jobs</strong>.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Proformy i faktury</h3>
      <h4 className="text-lg font-semibold mt-6 mb-2">
        Jak wystawić fakturę bez VAT?
      </h4>
      <p className="mb-4">
        Poniższe dotyczy klientów-firm. Osoby fizyczne zawsze otrzymują fakturę
        z VAT.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Klient z Polski – usługi zwolnione z VAT
      </h4>
      <p className="mb-4">
        Część usług ma zwolnienie przedmiotowe (np. lekcje językowe, szkolenia
        BHP – pełna lista w art. 43 ustawy o VAT). Jeśli Twoja usługa podlega
        zwolnieniu, po wypełnieniu <strong>Jednorazowa Umowa</strong> napisz do
        nas na{" "}
        <strong className="text-blue-500 underline">info@weexpert.io</strong> –
        usuniemy VAT z faktury dla klienta PL zgodnie z podstawą prawną.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Klient z zagranicy – zerowy VAT (reverse charge) dla firm
      </h4>
      <p className="mb-4">
        Firmom zagranicznym wystawiamy faktury ze stawką 0% / odwrotne
        obciążenie. Podatek VAT rozlicza klient w swoim kraju. Więcej o
        rozliczeniach z klientami zagranicznymi znajdziesz w naszym Help Center.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Płatności za faktury pro forma – najczęstsze pytania
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Czy dostanę potwierdzenie płatności?</strong> Tak. Gdy klient
          opłaci proformę, wyślemy Ci e-mail:
          <ul className="list-disc pl-6 space-y-1">
            <li>
              przy <strong>Jednorazowa Umowa</strong> – potwierdzimy wypłatę
            </li>
            <li>
              przy <strong>WeExpert Jobs</strong> – poinformujemy, że startuje
              czas realizacji
            </li>
          </ul>
        </li>
        <li>
          <strong>Klient nie podał numeru umowy w przelewie – co wtedy?</strong>{" "}
          W tytule przelewu musi być numer umowy z proformy. Jeśli go brak lub
          jest błędny, spróbujemy sami przypisać wpłatę (po danych
          umowy/użytkownika). Gdy to niemożliwe, zwrócimy środki klientowi.
        </li>
        <li>
          <strong>
            Klient nie opłacił proformy – czy dostanie moje pliki?
          </strong>{" "}
          Nie. Dopóki proforma nie jest opłacona, klient nie ma dostępu do
          pełnych plików. Dlatego nie wysyłaj prac poza WeExpert przed
          opłaceniem.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Klient nie otrzymał maila z fakturą – co zrobić?
      </h3>
      <p className="mb-4">
        Pobierz dokument w{" "}
        <strong>Pulpit → Jednorazowa Umowa → [Numer umowy] → Faktura</strong> i
        wyślij klientowi:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>proforma (z numerem konta i numerem umowy) lub</li>
        <li>faktura VAT (po płatności)</li>
      </ul>
      <p className="mb-4">
        Jeśli klient „nie dostaje” naszych maili, niech doda domenę{" "}
        <strong className="text-blue-500 underline">weexpert.io</strong> do
        wyjątków anty-spam/odrzucań.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Klient spóźnia się z płatnością – co dalej?
      </h3>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          Wystaw fakturę:
          <ul className="list-disc pl-6 space-y-1">
            <li>Brak płatności w terminie → umowa zrywana automatycznie.</li>
            <li>
              Jeśli klient zapłaci do 30 dni po terminie → umowa otworzy się
              automatycznie i wypłacimy Ci środki.
            </li>
            <li>
              Później niż 30 dni → klient powinien napisać na{" "}
              <strong className="text-blue-500 underline">
                info@weexpert.io
              </strong>{" "}
              z nowym realnym terminem płatności.
            </li>
          </ul>
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Zmiany na proformie i fakturze VAT
      </h3>
      <h4 className="text-lg font-semibold mt-6 mb-2">
        Jak zmienić dane / treść na proformie (przed płatnością)?
      </h4>
      <p className="mb-4">
        Napisz na{" "}
        <strong className="text-blue-500 underline">info@weexpert.io</strong> –
        możemy zaktualizować m.in.:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>imię i nazwisko / nazwę firmy, adres klienta,</li>
        <li>tytuł (nazwa pracy) i opis,</li>
        <li>kwotę, walutę, termin płatności proformy, czas realizacji,</li>
        <li>wybór w zakresie praw autorskich.</li>
      </ul>
      <p className="mb-4">
        Klient-firma może też samodzielnie zmienić nazwę/adres firmy po
        zalogowaniu – proforma pozostanie bez zmian, ale faktura VAT będzie
        wystawiona na nowe dane.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Jak skorygować fakturę VAT (po płatności)?
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Nota korygująca – wystawia klient (np. nazwa odbiorcy, nazwa usługi) i
          wysyła na{" "}
          <strong className="text-blue-500 underline">info@weexpert.io</strong>.
        </li>
        <li>
          Faktura korygująca – wystawia WeExpert (np. obniżenie wartości) na
          prośbę klienta.
        </li>
      </ul>
      <p className="mb-4">
        Daty wystawionej faktury VAT nie zmieniamy – to dzień zaksięgowania
        płatności.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">Jak zmienić cenę?</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Na proformie (przed płatnością): napisz na{" "}
          <strong className="text-blue-500 underline">info@weexpert.io</strong>{" "}
          – potwierdzimy z drugą stroną i wyślemy nową proformę.
        </li>
        <li>
          Na fakturze VAT (po płatności): zgłoś do nas – wystawimy korektę.
        </li>
      </ul>
      <p className="mb-4">
        Kwota brutto dla freelancera = kwota netto na fakturze dla klienta. W
        razie wątpliwości użyj kalkulatora i pamiętaj, że wybór dot. praw
        autorskich wpływa na Twoją wypłatę, ale nie na kwotę na fakturze.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Wydłużenie terminu płatności
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Płatność do 30 dni po terminie – wszystko dzieje się automatycznie.
        </li>
        <li>
          Później – klient zgłasza nowy termin na{" "}
          <strong className="text-blue-500 underline">info@weexpert.io</strong>.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Zmiana adresu e-mail zleceniodawcy
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Klient bez konta – prześlij nam stary i nowy e-mail klienta,
          sprawdzimy możliwość zmiany.
        </li>
        <li>
          Klient z kontem – niech napisze bezpośrednio na{" "}
          <strong className="text-blue-500 underline">info@weexpert.io</strong>.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak wyglądają faktury w WeExpert?
      </h3>
      <h4 className="text-lg font-semibold mt-6 mb-2">Proforma</h4>
      <p className="mb-4">
        To oferta handlowa, nie dokument księgowy (bez NIP i daty wystawienia).
        Zawiera szczegóły zamówienia. Proformę znajdziesz w{" "}
        <strong>Jednorazowa Umowa → [Numer umowy] → Faktura</strong>. Błędy
        (dane, nazwa usługi, kwota)? – zgłoś na{" "}
        <strong className="text-blue-500 underline">info@weexpert.io</strong>.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">Faktura VAT</h4>
      <p className="mb-4">
        Generujemy i wysyłamy po zaksięgowaniu płatności za proformę. Dla firm
        zagranicznych wystawiamy reverse charge (VAT 0%) – klient rozlicza VAT w
        swoim kraju.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Pliki z pracą (dzieło)
      </h3>
      <p className="mb-4">Każda umowa wymaga dodania plików:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Umowa o dzieło – wgrywasz ukończone dzieło / fragmenty / dowód
          ukończenia (np. screeny, raport).
        </li>
        <li>Umowa zlecenia – wgrywasz formularz godzinowy.</li>
      </ul>
      <p className="mb-4">
        To chroni Ciebie (dostęp dla klienta dopiero po płatności) i nas
        (legalne rozliczenie na podstawie umowy cywilnoprawnej).
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">Jak dodać pliki?</h4>
      <p className="mb-4">
        Wystaw fakturę – w ostatnim kroku formularza dodajesz pliki (akceptujemy
        wszystkie formaty; max 5 plików, do 16 MB łącznie).
      </p>
      <p className="mb-4">
        NDA / dane poufne – dodaj fragmenty bez danych wrażliwych lub je
        zamaskuj. Alternatywnie klient niech napisze do nas – wyślemy
        oświadczenie o przechowaniu utworu przez 5 lat i udostępnieniu go na
        żądanie organów.
      </p>
      <p className="mb-4">
        Nie masz dostępu do plików? – poproś klienta o screeny lub linki
        potwierdzające efekt pracy.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jakie pliki dodać? (przykłady)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Serwisy www / programowanie / IT – screeny, fragmenty kodu, pliki
          wynikowe.
        </li>
        <li>
          Multimedia (foto/wideo) – klatki/trailer, kilka zdjęć, screen folderu
          z miniaturami.
        </li>
        <li>
          Marketing (copy/social/SEO) – pliki tekstowe, screeny paneli, zestaw
          linków/postów, raport (np. z GA).
        </li>
        <li>
          Design – JPG/PNG/PDF, screen strony z grafikami, screen folderu z
          siatką prac.
        </li>
        <li>
          Tłumaczenia – plik z tłumaczeniem, plik z identyfikacją zlecenia
          poufnego/hasło (przy porozumieniu), protokół dla tłumaczeń ustnych.
        </li>
        <li>
          Prace biurowe – screeny potwierdzeń, dokumenty, raporty ilościowe.
        </li>
        <li>Zlecenia dla studentów / inne zlecenia – formularz godzinowy.</li>
        <li>Inne usługi – protokół zdawczo-odbiorczy.</li>
      </ul>
      <p className="mb-4">
        Każda umowa wymaga: całości prac albo obszernych fragmentów albo
        wiarygodnego potwierdzenia wykonania.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Prawa autorskie</h3>
      <h4 className="text-lg font-semibold mt-6 mb-2">Co to jest licencja?</h4>
      <p className="mb-4">W WeExpert możesz:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          udzielić licencji (niewyłącznej, na 15 lat) – klient korzysta z
          utworu, Ty zachowujesz prawa i możesz sprzedawać dalej,
        </li>
        <li>
          przenieść prawa majątkowe – klient nabywa je w całości i na zawsze.
        </li>
      </ul>
      <p className="mb-4">
        Dokument potwierdzający licencję/transfer przesyłamy elektronicznie.
        Udzielenie licencji lub przeniesienie praw może umożliwić KUP 50%
        (niższy podatek = wyższa wypłata), gdy praca spełnia warunki.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">Co wybrać?</h4>
      <h5 className="text-base font-semibold mt-4 mb-2">
        Przeniesienie praw autorskich
      </h5>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>
          Dobre dla unikatowych, niesprzedawalnych prac (np. strona www, film,
          muzyka, tekst marketingowy, projekt architektoniczny).
        </li>
        <li>Praw majątkowych zrzekasz się trwale.</li>
      </ul>

      <h5 className="text-base font-semibold mt-4 mb-2">
        Licencja (15 lat, niewyłączna)
      </h5>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Dobre dla rozwiązań wielokrotnego użytku (np. aplikacja, skrypt,
          library).
        </li>
        <li>Zachowujesz prawa i możesz dalej monetyzować.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Porównanie: Licencja vs Przeniesienie praw
      </h3>
      <table className="w-full border border-gray-300 text-left mb-6">
        <thead className="bg-gray-100">
          <tr>
            <th className="border border-gray-300 px-4 py-2">Cecha</th>
            <th className="border border-gray-300 px-4 py-2">Licencja</th>
            <th className="border border-gray-300 px-4 py-2">
              Przeniesienie praw
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-gray-300 px-4 py-2">
              Korzystanie przez klienta
            </td>
            <td className="border border-gray-300 px-4 py-2">Tak (15 lat)</td>
            <td className="border border-gray-300 px-4 py-2">
              Tak (na zawsze)
            </td>
          </tr>
          <tr>
            <td className="border border-gray-300 px-4 py-2">
              Dalsza sprzedaż przez Ciebie
            </td>
            <td className="border border-gray-300 px-4 py-2">Tak</td>
            <td className="border border-gray-300 px-4 py-2">Nie</td>
          </tr>
          <tr>
            <td className="border border-gray-300 px-4 py-2">Dokumenty</td>
            <td className="border border-gray-300 px-4 py-2">
              Protokół (e-podpis)
            </td>
            <td className="border border-gray-300 px-4 py-2">
              Protokół (e-podpis)
            </td>
          </tr>
          <tr>
            <td className="border border-gray-300 px-4 py-2">KUP 50%</td>
            <td className="border border-gray-300 px-4 py-2">Nie</td>
            <td className="border border-gray-300 px-4 py-2">
              Często tak (zależnie od pracy)
            </td>
          </tr>
        </tbody>
      </table>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak to działa w WeExpert (kulisy)?
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          Prawa przechodzą od Ciebie do <strong>WeExpert</strong> (umowa
          cywilnoprawna).
        </li>
        <li>
          Następnie od WeExpert do klienta (sprzedaż utworu).
 Wybór (przeniesienie / brak) wskazujesz w formularzu (Jednorazowa umowa). Wszystko online – bez papierów.
        </li>
        <li>
          Wybór (licencja / przeniesienie / brak) wskazujesz w formularzu (
          <strong>Jednorazowa umowa</strong>). Wszystko online – bez papierów.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Podwyższone koszty uzyskania przychodu (KUP 50%)
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Standard w umowie o dzieło: KUP 20%.</li>
        <li>
          Dla wielu prac twórczych (programy komputerowe, grafika, muzyka,
          działalność publicystyczna, część tłumaczeń, B+R itd.) – przy
          transferze można zastosować KUP 50% → niższy podatek = wyższa wypłata.
        </li>
        <li>
          Przykłady:
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Aplikacja mobilna – transfer TAK, KUP 50% TAK → podatek niższy.
            </li>
            <li>
              Tłumaczenie symultaniczne – licencja/transfer NIE, KUP 50% NIE.
            </li>
          </ul>
        </li>
        <li>
          Limity: do 240 000 zł przychodu rocznie (co odpowiada 120 000 zł
          kosztów). Po przekroczeniu – kolejne umowy z KUP 20%.
        </li>
        <li>
          Jeżeli wybierzesz licencję/transfer przy pracy, która się do tego nie
          kwalifikuje, opcja zostanie usunięta podczas weryfikacji (podatek może
          wzrosnąć, wypłata spaść). O wszystkim informujemy
          e-mailem/telefonicznie.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak przekazać prawa autorskie w WeExpert?
      </h3>
      Gdy rozliczasz się z klientem przez WeExpert, w formularzu wybierasz, co robimy z Twoimi majątkowymi prawami autorskimi do pracy:
      <ul className="list-disc pl-6 space-y-1 mb-6">
     
        <li>
          Przenoszę prawa autorskie – trwale i w całości oddajesz prawa
          klientowi.
        </li>
        <li>Nie przekazuję praw / bez licencji.</li>
      </ul>
      Zobacz też różnice i konsekwencje podatkowe w sekcjach poniżej.

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Procedura (prosty proces online)
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Wybór opcji robisz jednym kliknięciem w formularzu.</li>
        <li>
          Nic nie drukujesz – wszystko odbywa się online, wysyłamy link do
          podpisu.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Gdzie zaznaczyć opcję?
      </h3>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>
          W kroku z kalkulatorem wynagrodzenia masz trzy przełączniki:
          <ul className="list-disc pl-6 space-y-1">
            <li>Prawa autorskie</li>
            <li>Licencja</li>
            <li>Brak przeniesienia praw autorskich (bez licencji)</li>
          </ul>
        </li>
        <li>
          Po zmianie opcji kalkulator może zaktualizować Twoją wypłatę netto
          (patrz KUP 50%). Kwota nie zmieni się, jeżeli:
          <ul className="list-disc pl-6 space-y-1">
            <li>do danej pracy nie można przekazać praw / udzielić licencji</li>
            <li>
              do danej pracy nie stosuje się podwyższonych kosztów uzyskania
              przychodu (KUP 50%)
            </li>
          </ul>
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">Pomyłka w wyborze?</h3>
      <p className="mb-4">
        Jeśli wskażesz licencję/transfer przy pracy, która nie kwalifikuje się,
        usuniemy tę opcję podczas weryfikacji (to może podnieść podatek i
        obniżyć wypłatę). O wszystkim informujemy e-mailem/telefonicznie.
      </p>
      <p className="mb-6">
        Masz wątpliwości? Napisz:{" "}
        <strong className="text-blue-500 underline">info@weexpert.io</strong> –
        podpowiemy właściwą opcję.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dokumenty po rozliczeniu
      </h3>
      <p className="mb-4">
        Po zamknięciu umowy wyślemy dokumenty i znajdziesz je także w: Umowy jednorazowy  → Wybierz umowę → Wybierz plik (Faktura/Pro-forma/Umowa/Rachunek) 
        <strong>Kontrakty → Wygeneruj PDF</strong>,{" "}
        <strong>Rachunki → Wygeneruj PDF</strong>.
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-6">
        <li>Licencja – potwierdzenie od razu po rozliczeniu.</li>
        <li>
          Przeniesienie praw – do 7 dni roboczych:
          <ul className="list-disc pl-6 space-y-1">
            <li>Ty: „Umowa o Dzieło z przeniesieniem praw autorskich”</li>
            <li>
              Klient: „Protokół przeniesienia majątkowych praw autorskich”
            </li>
          </ul>
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Do jakich prac można zastosować KUP 50%?
      </h3>
      <p className="mb-6">
        KUP 50% (niższy podatek → wyższa wypłata) działa przy pracach twórczych,
        gdy wybierzesz przeniesienie praw. Nie wszystkie prace się kwalifikują.
      </p>
      <h3 className="text-xl font-semibold mt-10 mb-4">Szybka tabela</h3>
      <div className="overflow-x-auto mb-6">
        <table className="table-auto border border-gray-300 w-full text-left">
          <thead>
            <tr className="">
              <th className="border px-4 py-2">Można transfer</th>
              <th className="border px-4 py-2">KUP 50%</th>
              <th className="border px-4 py-2">Podatek niższy</th>
              <th className="border px-4 py-2">Przykład</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">TAK</td>
              <td className="border px-4 py-2">TAK</td>
              <td className="border px-4 py-2">TAK</td>
              <td className="border px-4 py-2">
                stworzenie aplikacji mobilnej
              </td>
            </tr>
            <tr>
              <td className="border px-4 py-2">NIE</td>
              <td className="border px-4 py-2">NIE</td>
              <td className="border px-4 py-2">NIE</td>
              <td className="border px-4 py-2">
                zarządzanie kampaniami Google Ads
              </td>
            </tr>
            <tr>
              <td className="border px-4 py-2">NIE</td>
              <td className="border px-4 py-2">NIE</td>
              <td className="border px-4 py-2">NIE</td>
              <td className="border px-4 py-2">tłumaczenie symultaniczne</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 className="text-xl font-semibold mt-10 mb-4">
        Prace z transferem i KUP 50% (przykłady)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Programowanie & IT:</strong> aplikacje web/mobile,
          oprogramowanie (z realnymi zmianami w kodzie).
        </li>
        <li>
          <strong>Serwisy www:</strong> tworzenie/modyfikacja stron, sklepów;
          szablony ze skryptowaniem.
        </li>
        <li>
          <strong>Multimedia:</strong> animacje, wideo/film, montaż promo, sesje
          i obróbka zdjęć, muzyka (nagranie/edycja/wykonanie), produkcja AV
          (reżyseria, scenariusz, zdjęcia, dźwięk).
        </li>
        <li>
          <strong>Design/Architektura:</strong> projekty UI/UX, grafika 2D/3D,
          architektura/wnętrza/krajobraz/urbanistyka.
        </li>
        <li>
          <strong>Teksty:</strong> literatura piękna; dziennikarstwo (publikacja
          w tytule prasowym); publicystyka (pełne artykuły, link do publikacji).
        </li>
        <li>
          <strong>Tłumaczenia:</strong> książki, artykuły, poezja, strony www,
          inne tłumaczenia twórcze.
        </li>
        <li>
          <strong>Inne:</strong> prace naukowe/B+R/dydaktyczne, scenografia,
          kostiumy (nie odzież), lutnictwo, choreografia, charakteryzacja,
          sztuka ludowa.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Prace z licencją, ale bez KUP 50% (przykłady)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>IT:</strong> drobne aktualizacje (np. aktualizacja wtyczki).
        </li>
        <li>
          <strong>WWW:</strong> wprowadzanie treści/produktów (bez twórczej
          ingerencji w kod).
        </li>
        <li>
          <strong>Marketing & teksty:</strong> Google Ads mgmt, opisy
          produktów/kategorii, materiały szkoleniowe/webinary, prowadzenie
          sociali (posty/grafiki), analityka, e-mail marketing (treści).
        </li>
        <li>
          <strong>Biurowe:</strong> bazy danych.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Prace, gdzie nie wolno licencji/transferu (i brak KUP 50%)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>Administracja/zarządzanie serwerem</li>
        <li>Operator kamery</li>
        <li>Redakcja/korekta</li>
        <li>Audyt SEO</li>
        <li>Obsługa klienta, telesprzedaż, wysyłka maili</li>
        <li>
          Tłumaczenia pisemne dokumentów oraz tłumaczenia ustne/symultaniczne
        </li>
        <li>Wirtualna asysta</li>
        <li>Dodawanie treści/produktów/piosenek</li>
        <li>Wypełnianie wniosków</li>
        <li>
          Przy umowach zlecenia nie stosujemy licencji/transferu (dotyczy tylko
          umów o dzieło)
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Prawa autorskie – podstawy
      </h3>
      <p className="mb-2">
        <strong>Co to jest „utwór”?</strong>
        <br />
        Każde oryginalne, indywidualne dzieło twórcze (np. grafika, wideo,
        program, artykuł).
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">Dwa rodzaje praw</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Osobiste:</strong> autorstwo, integralność utworu, pierwsze
          udostępnienie. Niezbywalne.
        </li>
        <li>
          <strong>Majątkowe:</strong> czerpanie korzyści (sprzedaż,
          zwielokrotnianie, udostępnianie, licencje). Można nimi rozporządzać.
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Jak rozporządzać prawami majątkowymi w WeExpert?
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Licencja (15 lat, niewyłączna):</strong> klient korzysta, Ty
          nadal możesz sprzedawać/wykorzystywać.
        </li>
        <li>
          <strong>Przeniesienie praw:</strong> klient nabywa całość praw na
          zawsze; Ty już nie monetyzujesz dzieła.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Porównanie: Licencja vs Przeniesienie praw
      </h3>
      <table className="w-full border border-gray-200 text-left mb-6">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2">Cecha</th>
            <th className="border px-4 py-2">Licencja</th>
            <th className="border px-4 py-2">Przeniesienie praw</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-4 py-2">Twoja dalsza sprzedaż</td>
            <td className="border px-4 py-2">Tak</td>
            <td className="border px-4 py-2">Nie</td>
          </tr>
          <tr>
            <td className="border px-4 py-2">Czas</td>
            <td className="border px-4 py-2">15 lat</td>
            <td className="border px-4 py-2">Bezterminowo</td>
          </tr>
          <tr>
            <td className="border px-4 py-2">Formalności</td>
            <td className="border px-4 py-2">Bez dodatkowych dokumentów</td>
            <td className="border px-4 py-2">Protokół (e-podpis)</td>
          </tr>
        </tbody>
      </table>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Wynagrodzenia i metody płatności
      </h3>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Kiedy dostanę wypłatę? – Jednorazowa Umowa
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Masz gotową pracę → dodajesz pliki → klient opłaca proformę →
          (opcjonalnie: faktura VAT od Ciebie, jeśli masz firmę) → wypłata.
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Jak dodać metodę wypłaty?
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Zaloguj się → Pulpit → Moje dokumenty → Główna Informacja →  dodaj Numer Rachunku dla każdej waluty, której używasz (PLN, EUR, GBP, USD, CHF, CAD). Dla innej metody najpierw skontaktuj się z n
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">Ile to trwa?</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Wypłaty w dni robocze, zwykle w 24 h, wyjątkowo do 3 dni (zależnie od
          banku).
        </li>
        <li>Waluty obce – do 3 dni roboczych.</li>
        <li>
          Przelewy realizujemy dwa razy dziennie (pn–pt): ok. 11:00 i 14:00.
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">Przelew ekspresowy</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>W dni robocze, 9:00–16:00 (jeśli Twój bank obsługuje).</li>
        <li>
          Jak zamówić: po mailu o zaksięgowaniu wpłaty klienta, napisz na{" "}
          <strong>info@weexpert.io</strong> z tematem „PRZELEW EKSPRESOWY” i
          numerem umowy.
        </li>
        <li>Opłaty: PLN – 20 zł, EUR/USD/GBP – 10 EUR/USD/GBP.</li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Jak WeExpert wypłaca wynagrodzenie?
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>Wypłaty dni powszednie, ok. 11:00 i 14:00.</li>
        <li>PLN i waluty – standardowy przelew bankowy.</li>
        <li>
          Podatek: jeśli rozliczasz w Polsce, potrącana zaliczka na PIT → kwota
          netto.
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Netto czy brutto – jak liczymy Twoją wypłatę?
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Wypłata zwykle netto (po podatku). Mogą wystąpić składka zdrowotna i
          opłata serwisowa.
        </li>
        <li>
          Kalkulator: „Netto (Ty zarobisz na rękę)” ↔ „Brutto (Twój klient
          zapłaci)”.
        </li>
        <li>
          Przykłady: 500 zł netto → pokazuje kwotę dla klienta, 500 zł brutto →
          pokazuje Twoją wypłatę.
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">Opłata serwisowa</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>Brutto po lewej → Twoja wypłata pomniejszona o 5% (max 499 zł).</li>
        <li>Netto po lewej → opłata doliczana do kwoty na fakturze klienta.</li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">Podatek</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Wysokość podatku zależy m.in. od:
          <ul className="list-disc pl-6 space-y-1">
            <li>czy przekazujesz prawa autorskie / udzielasz licencji,</li>
            <li>czy dla tej pracy można zastosować KUP 50%.</li>
          </ul>
        </li>
        <li>
          Spełnienie obu zwykle obniża podatek. Szczegóły w artykułach o prawach
          autorskich i KUP 50%.
        </li>
      </ul>

      <ul className="list-disc pl-6 space-y-1 mt-4">
        <li>
          Nie potrącamy podatku, jeśli:
          <ul className="list-disc pl-6 space-y-1">
            <li>Polska nie jest Twoim krajem zamieszkania (na profilu),</li>
            <li>
              rozliczasz umowę zlecenia i masz poniżej 26 lat oraz posiadasz
              status Studenta.
            </li>
          </ul>
        </li>
      </ul>

      <p className="mt-4">
        Kalkulator jest orientacyjny – nie uwzględnia rodzaju pracy. Jeśli Twoja
        praca nie kwalifikuje się do KUP 50%, rzeczywista wypłata może być
        niższa niż w kalkulatorze z zaznaczonym „przekazaniem praw”.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Klient spoza Polski</h3>
      <p>
        Zasady podatku i wyliczeń pozostają takie same. Walutę umowy ustawiasz: PLN, EUR, USD, GBP, CHF, CAD. Aby dostać przelew w danej walucie, dodaj metodę wypłaty dla tej waluty.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        „Dostałem mail, że klient zapłacił, ale nie mam przelewu” – checklista
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>dodałeś pliki do umowy,</li>
        <li>klient zaakceptował (ma na to 7 dni),</li>
        <li>masz dodaną metodę wypłaty/numer konta,</li>
        <li>
          jeśli masz Konto firmowe – wgrałeś fakturę/rachunek (link w mailu).
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak dodać fakturę/rachunek (Konto firmowe)
      </h3>
      <p>
        Przed wypłatą poprosimy o fakturę na dane WeExpert (wyślemy je mailem).
        Dodaj dokument:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>z maila (link)</li>
      </ul>
      <p>Błąd? Odrzucimy plik i poprosimy o poprawioną wersję.</p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Metody wypłaty (PLN i waluty)
      </h3>
      <p>
        Waluta umowy: PLN / EUR / USD / GBP / CHF. Wypłacamy na metodę dodaną
        dla tej samej waluty.
      </p>
      <p>
        Przykład 1: mieszkasz w Czechach, chcesz korony CZK → ustaw EUR jako
        walutę umowy, a w metodach wypłaty dla EUR dodaj konto bankowe lub Wise
        w CZK.
      </p>
      <p>
        Przykład 2: klient z USA chce USD, a Ty chcesz PLN → ustaw USD w umowie,
        a jako metodę dla USD dodaj polskie konto, Wise lub PayPal (bank może
        przewalutować).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dostępne metody (zależnie od kraju zamieszkania na profilu)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Freelancer z Polski</strong>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Wypłaty z umów w PLN → polskie konto bankowe / konto w innej
              walucie / PayPal / Wise / Revolut
            </li>
            <li>Z umów w EUR/USD/GBP/CHF → konto bankowe / Wise / Revolut</li>
          </ul>
        </li>
        <li>
          <strong>Freelancer z SEPA (zagranica)</strong>
          <ul className="list-disc pl-6 space-y-1">
            <li>Z PLN/GBP → konto bankowe / Wise / Revolut</li>
            <li>Z EUR/USD/CHF → konto bankowe / Wise / Payoneer / Revolut</li>
          </ul>
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Freelancer spoza SEPA
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>Wypłaty z PLN/GBP → konto bankowe / PayPal / Wise.</li>
        <li>Z EUR/USD → konto bankowe / PayPal / Wise / Payoneer.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">Ważne przy walutach</h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Zagraniczne konto bankowe może powodować przewalutowanie (kurs i
          opłaty banku).
        </li>
        <li>
          USD na konto bankowe: najlepiej konto w USA albo zweryfikowane konto
          Wise – unikniesz podwójnego przewalutowania.
        </li>
        <li>
          Wise – wielowalutowe konto; często najkorzystniejsze koszty wymiany.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">Terminy wypłat</h3>
      <p>
        Wysyłamy wypłaty w dni robocze. Najczęściej docierają w 24 h, czasem do
        3 dni (bank). Waluty obce: nawet do 3 dni. Chcesz szybciej? Napisz na
        info@weexpert.io (temat: PRZELEW EKSPRESOWY).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Podatki</h3>
      <p>
        To, czy potrącamy podatek, zależy od kraju zamieszkania i statusu
        prawnego na profilu.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Osoba fizyczna z Polski (bez firmy)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>Potrącamy zaliczkę na PIT → wysyłamy wypłatę netto.</li>
        <li>
          Jeśli w roku rozliczysz min. jedną umowę – do 28 lutego wyślemy PIT-11
          (do pobrania na koncie).
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">Drugi próg</h3>
      <p>
        Gdy przekroczysz pierwszy próg, prześlij nam oświadczenie (wzór
        udostępniamy) na info@weexpert.io – zastosujemy 32%. Jeśli nie zgłosisz
        przekroczenia, potrącamy 12%, a US wezwie do dopłaty po zeznaniu
        rocznym.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Kiedy nie potrącamy podatku?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Na profilu masz kraj inny niż Polska (prześlij potwierdzenie
          rezydencji podatkowej – np. certyfikat).
        </li>
        <li>Konto firmowe (rozliczasz we własnej działalności).</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        „Zerowy PIT dla młodych”
      </h3>
      <p>
        Dotyczy umów zlecenia (czas i staranność), osób 26 lat. Aby skorzystać w
        WeExpert:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>masz &lt;26 lat,</li>
        <li>
          masz status studenta lub osoby zatrudnionej i dostajesz więcej niż
          minimalne wynagrodzenie,
        </li>
        <li>rozliczana praca kwalifikuje się do umowy zlecenia,</li>
        <li>jako plik z pracą dodajesz formularz godzinowy.</li>
      </ul>
      <p>
        Limit: do 85 528 zł przychodu w roku – 0%; powyżej → 12% (albo 32% po
        przekroczeniu drugiego progu).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">PIT-11</h3>
      <p>Wysyłamy na konto w WeExpert do 28 lutego. Zawiera:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Nie wysyłamy PIT-11, jeśli w roku:</li>
      </ul>
      <ul className="list-disc pl-12 space-y-1">
        <li>nie masz zrealizowanych umów,</li>
        <li>nie potrącaliśmy podatku,</li>
      </ul>
      <p>
        Jak pobrać lub masz błąd w PIT-11? Napisz do nas (imię/nazwisko, data
        urodzenia, PESEL, adres). Chcesz zebrać dane do progów? Daj znać –
        wyślemy zestawienie Twoich umów.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dla zleceniodawcy (klienta)
      </h3>
      <p>Co zyskujesz w WeExpert?</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Faktura VAT zamiast umów cywilnoprawnych z osobą fizyczną.</li>
        <li>Umowy online jako zabezpieczenie przed startem prac.</li>
        <li>
          Mniej formalności po Twojej stronie – zgłoszenia ZUS, podatki i
          wypłaty ogarniamy my.
        </li>
        <li>Jeśli nie masz wykonawcy – znajdziesz go w WeExpert Jobs.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak rozliczyć wykonawcę?
      </h3>
      <p>Dwa sposoby:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Freelancer wypełnia Jednorazowa umowa.</li>
        <li>Ty podpiszesz Protokół praw autorskich (jeśli dotyczy).</li>
      </ul>
      <p>
        Po wgraniu plików przez wykonawcę wysyłamy Ci proformę; po opłaceniu
        dostajesz fakturę VAT, a wykonawca – wynagrodzenie.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Customer Service i kontakt
      </h3>
      <p>
        Pon.–pt. 8:00–17:00 jesteśmy do dyspozycji. Napisz przez formularz
        kontaktowy lub na info@weexpert.io. (Z przyjemnością odpowiemy na Twoje
        pytania!)
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy WeExpert jest legalny?
      </h3>
      <p>
        Tak. Rozliczamy zgodnie z polskim prawem: zawieramy z freelancerami
        umowy cywilnoprawne w formie elektronicznej i legalnie sprzedajemy
        efekty ich pracy klientom (FV VAT). Dla polskich freelancerów
        odprowadzamy PIT i co roku wystawiamy PIT-11. Ty dostajesz fakturę VAT
        bez formalności — przejmujemy je na siebie.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Kto może legalnie korzystać?
      </h3>
      <p>
        Każdy zleceniodawca (osoba prywatna lub firma, w Polsce i za granicą)
        rozliczający pojedyncze zlecenia lub stałe projekty.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Umowa między WeExpert a freelancerem
      </h3>
      <p>
        To my zawieramy z wykonawcą umowę o dzieło (a w uzasadnionych
        przypadkach umowę zlecenia).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Faktura VAT</h3>
      <p>
        Po wypełnieniu formularza wysyłamy fakturę pro forma. Po jej opłaceniu:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>wypłacamy wynagrodzenie freelancerowi,</li>
        <li>do Ciebie trafia faktura VAT.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Podatek dochodowy i ZUS (dla polskich freelancerów)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Odprowadzamy PIT od umów cywilnoprawnych i przekazujemy go do US.
        </li>
        <li>
          Zgłaszamy każdą umowę do ZUS. Przy umowie o dzieło składek ZUS nie ma;
          przy umowie zlecenia naliczamy składkę zdrowotną.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Limity i „działalność nierejestrowana”
      </h3>
      <p>
        Limitów liczby umów/braku działalności nie ma. Regularne rozliczanie
        przez WeExpert nie wymaga zakładania działalności ani etatu.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Faktura „od freelancera” w WeExpert — jak to działa?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>szybciej i online, bez papierologii,</li>
        <li>mniej pracy księgowości (brak własnych umów o dzieło/zlecenia),</li>
        <li>bierzemy na siebie zgłoszenia do ZUS i podatki,</li>
        <li>otrzymujesz FV VAT nawet gdy wykonawca nie ma firmy.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czym to się różni od Twojej własnej umowy o dzieło?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Tradycyjnie: sam klasyfikujesz pracę, zgłaszasz do ZUS, dbasz o PIT.
        </li>
        <li>
          Z WeExpert: to my bierzemy odpowiedzialność. Ty/wykonawca tylko
          wypełniacie formularz.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">Proforma — po co?</h3>
      <p>
        To oferta, nie dokument księgowy. Zmiany (np. danych) zgłaszasz wygodnie
        przed wystawieniem FV. NIP pojawi się dopiero na fakturze VAT.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Umowy i bezpieczeństwo
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Umowa o dzieło/zlecenia powstaje po opłaceniu proformy (obie strony
          potwierdzają transakcję).
        </li>
        <li>
          Bezpieczeństwo: środki trafiają do freelancera dopiero po dodaniu i
          akceptacji plików.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jakie prace rozliczysz?
      </h3>
      <p>
        Najczęściej: serwisy www, multimedia (wideo, audio, foto),
        programowanie/IT, marketing (Ads, social, SEO, analityka, e-mail,
        telemarketing), design (2D/3D, UX/UI, architektura), tłumaczenia, prace
        biurowe (VA, bazy, wnioski, customer service).
      </p>
      <p>
        Wymagane są pliki z pracą lub dowody wykonania (np. zrzuty ekranu,
        linki). Prace czasowe też rozliczysz (warunki jak dla umowy zlecenia);
        plikiem potwierdzającym jest formularz godzinowy (np. nauka języka,
        obsługa klienta/sprzedaży, doradztwo/konsultacje, prezentacje). Możliwe
        też rozliczenia najmu (sprzęt, studio, hosting/reklama; z wyłączeniem
        wynajmu aut).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Moje konto (zleceniodawca)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Pulpit — przegląd bieżących rozliczeń; po tygodniu od wypłaty umowy
          trafiają do Umów Jednorazowych. (Szukaj po: freelancer, tytuł umowy,
          datach).
        </li>
        <li>
          Kalkulator — orientacyjna wycena (Twoja wypłata vs kwota dla klienta).
        </li>
        <li>Umowy — statusy, szczegóły, dokumenty.</li>
        <li>Wiadomości — korespondencja z wykonawcami.</li>
        <li>WeExpert Jobs — oferty, baza freelancerów.</li>
        <li>Help Center — szybkie odpowiedzi na najczęstsze pytania.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak edytować dane konta?
      </h3>
      <p>Moje Dokumenty</p>
      <p>
        Tych danych nie zmienisz samodzielnie: adres e-mail konta, NIP, status
        prawny (firma/osoba fizyczna). Aby je zaktualizować, napisz do nas przez
        formularz kontaktowy.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Jak aktywować konto, jeśli już rozliczasz przez WeExpert?
      </h3>
      <p>
        To instrukcja dla osób, które choć raz rozliczyły wykonawcę przez
        WeExpert (mamy Twój e-mail i dane w bazie).
      </p>
      <p>Co daje konto?</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>pełny dostęp do dokumentów (proformy, FV, protokoły, licencje),</li>
        <li>szybkie zgłaszanie poprawek,</li>
        <li>korespondencja i lista wszystkich wykonawców,</li>
        <li>dostęp do plików z pracą,</li>
        <li>łatwe zarządzanie danymi do faktury.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Aktywacja krok po kroku
      </h3>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          Wejdź na ekran logowania i wpisz adres e-mail oraz swoje dane, na który dostajesz od nas wiadomości.
        </li>
        <li>Kliknij „Odzyskaj hasło”.</li>
        <li>Odbierz mail z linkiem aktywacyjnym.</li>
        <li>Ustaw hasło → konto aktywne.</li>
      </ol>
      <p>
        Chcesz mieć konto na innym e-mailu, ale jednocześnie dostęp do historii?
        Najpierw aktywuj konto na „stary” adres, potem napisz do nas – zmienimy
        e-mail przypisany do konta.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy w WeExpert zawierasz umowę z freelancerem?
      </h3>
      <p>
        Nie musisz sam(a) podpisywać cywilnoprawnej umowy z wykonawcą. Model
        wygląda tak:
      </p>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          WeExpert ↔ Freelancer – zawieramy z wykonawcą umowę o dzieło lub
          zlecenie.
        </li>
        <li>
          WeExpert kupuje rezultat pracy od freelancera (zajmujemy się
          podatkiem/ZUS).
        </li>
        <li>WeExpert sprzedaje tę pracę Tobie i wystawia fakturę VAT.</li>
      </ol>
      <p>
        Akceptując rozliczenie i płacąc proformę, akceptujesz Regulamin
        WeExpert.
      </p>
      <p>
        Po zakończeniu otrzymasz: licencję na korzystanie z dzieła albo protokół
        przeniesienia majątkowych praw autorskich (lub nic, jeśli wykonawca
        zachował prawa).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Czy mogę zrezygnować z umowy i ze współpracy?
      </h3>
      <p>
        To zależy od etapu rozliczenia. Napisz do nas przez formularz kontaktowy
        i opisz dokładnie sytuację (jaka umowa, na jakim etapie, powód
        rezygnacji). Pomożemy dobrać właściwy tryb.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Co jest potrzebne do rozliczenia
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>Zlecenie zostało wykonane i znasz efekt.</li>
        <li>
          Freelancer ma pliki potwierdzające wykonanie (dzieło lub potwierdzenie
          wykonania), które doda w formularzu.
        </li>
      </ul>
      <p>My zajmujemy się podatkami zgodnie z zasadami rozliczeń.</p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Faktury i płatności</h3>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Zmiany w fakturach korygujących (KSeF)
      </h3>
      <p>
        Od maja 2025 r. nie wystawiamy już korekt zmieniających datę wystawienia
        faktury. Data na fakturze VAT = dzień zaksięgowania Twojej wpłaty.
        (Przygotowania do KSeF od lutego 2026 r.; podstawa prawna: art. 106na
        ust. 1 ustawy o VAT).
      </p>
      <p>
        Wskazówka: jeśli zależy Ci na dacie z danego miesiąca – opłać proformę
        jak najszybciej.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Nie doszła faktura VAT – co zrobić?
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>Sprawdź spam.</li>
        <li>
          Poproś swojego dostawcę poczty o dodanie domeny weexpert.io do
          wyjątków.
        </li>
        <li>W razie czego – napisz do nas na info@weexpert.io.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Kiedy otrzymam fakturę VAT?
      </h3>
      <p>
        Po opłaceniu proformy i zaksięgowaniu środków. Proforma trafia na e-mail
        podany w formularzu.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Pro forma – co to jest i po co
      </h3>
      <h4 className="text-lg font-semibold mt-6 mb-2">Czym jest pro forma</h4>
      <p>
        To oferta handlowa z podsumowaniem zakresu i wartości zlecenia – pozwala
        sprawdzić dane i wprowadzić ewentualne korekty przed wystawieniem
        faktury VAT. Sama nie jest dokumentem księgowym ani podatkowym.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Pro forma vs faktura VAT
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Pro forma: oznaczona jako „pro forma”, brak skutków
          księgowo-podatkowych, brak NIP nabywcy.
        </li>
        <li>Faktura VAT: dokument księgowy po zaksięgowaniu płatności.</li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Dlaczego wysyłamy pro formę w WeExpert
      </h4>
      <p>
        Ułatwia weryfikację danych (nazwa odbiorcy, opis pozycji, wartość, itp.)
        i eliminuje korekty VAT. Opłacenie proformy = przyjęcie oferty i start
        realizacji rozliczenia (lub – w „Podpisz umowę” – przekazanie środków do
        bezpiecznego depozytu).
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        Jakie dane zawiera pro forma
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>Tytuł z adnotacją „pro forma” i numer.</li>
        <li>Dane wystawcy (WeExpert) i Twoje dane odbiorcy.</li>
        <li>
          Przedmiot transakcji, kwoty netto/brutto, stawka VAT, termin
          płatności.
        </li>
        <li>Bez NIP – NIP pojawia się dopiero na fakturze VAT.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Polityka Prywatności WeExpert
      </h3>
      <p>
        Administrator: WEEXPERT SP. Z O.O. z siedzibą we Wrocławiu, ul. Marsz.
        Józefa Piłsudskiego 74/320, 50-020 Wrocław, wpisaną do rejestru
        przedsiębiorców KRS prowadzonego przez Sąd Rejonowy dla
        Wrocławia-Fabrycznej, Wydział VI Gospodarczy Krajowego Rejestru Sądowego
        pod numerem KRS: 0000986528, NIP: 9671458021, REGON: 52278693000000
      </p>
      <p>Kontakt w sprawach danych: info@weexpert.io</p>

      <h4 className="text-lg font-semibold mt-6 mb-2">I. Zakres</h4>
      <p>
        Polityka opisuje sposób przetwarzania danych Użytkowników korzystających
        z serwisu weexpert.io (rejestracja, ogłoszenia, rozliczenia, płatności,
        komunikacja, KYC/AML). Korzystanie z serwisu oznacza akceptację
        Polityki.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">II. Kategorie danych</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Dane konta i profilowe (np. imię, nazwisko, adres, e-mail, tel.,
          NIP/PESEL, urząd skarbowy, rachunek, status prawny; treści profilu
          widoczne publicznie wg decyzji Użytkownika).
        </li>
        <li>
          Dane transakcyjne (ogłoszenia, oferty, umowy, płatności, wiadomości).
        </li>
        <li>
          Obsługa Użytkownika (reklamacje, wnioski; dane identyfikacyjne).
        </li>
        <li>
          Dane z urządzeń i stron (IP, identyfikatory, cookies – zgodnie z
          polityką cookies).
        </li>
        <li>
          Logowanie przez Google (ID, e-mail, imię/nazwisko, avatar – z
          możliwością odłączenia).
        </li>
        <li>Ankiety (dobrowolnie: dane i opinie w celach statystycznych).</li>
        <li>
          Weryfikacja tożsamości KYC (imię, nazwisko, data urodzenia; skan/dane
          dokumentu; przetwarzanie przez dostawców KYC).
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">III. Cele i podstawy</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Umowa/świadczenie usług: prowadzenie kont, umów i rozliczeń;
          płatności; komunikacja; bezpieczeństwo i egzekwowanie Regulaminu.
        </li>
        <li>
          Obowiązek prawny: podatki/rachunkowość; AML/KYC; bezpieczeństwo usług;
          whistleblowing; zgodność z RODO.
        </li>
        <li>
          Prawnie uzasadniony interes: analityka, bezpieczeństwo IT, marketing
          własny (w tym dopasowanie treści), statystyka, archiwizacja i obrona
          roszczeń, reCAPTCHA, moderacja komentarzy.
        </li>
        <li>
          Zgoda: cookies i podobne; ankiety; przekazy do partnerów
          reklamowych/fintech (tam, gdzie wymagane).
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">IV. Udostępnianie</h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>Strony transakcji (w niezbędnym zakresie).</li>
        <li>
          Podmioty przetwarzające dla WeExpert (hosting/ICT, mailing,
          księgowość, windykacja, KYC, marketing, obsługa klienta) – na
          podstawie umów powierzenia.
        </li>
        <li>Organy publiczne (na podstawie prawa).</li>
        <li>
          Transfer poza EOG możliwy (np. Google/Meta/KYC/Bitrix24); z
          odpowiednimi zabezpieczeniami.
        </li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">
        V. Przechowywanie i bezpieczeństwo
      </h4>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Dane przechowujemy: przez okres trwania konta albo do 5 lat od
          ostatniej umowy – stosuje się dłuższy z tych okresów, chyba że
          przepisy wymagają inaczej.
        </li>
        <li>Zabezpieczenia techniczne i organizacyjne zgodne z RODO/AML.</li>
      </ul>

      <h4 className="text-lg font-semibold mt-6 mb-2">VI. Prawa Użytkownika</h4>
      <p>
        Dostęp, kopia, sprostowanie, usunięcie, ograniczenie, sprzeciw (w tym
        marketing), przenoszenie, cofnięcie zgody, skarga do PUODO. Kontakt:
        info@weexpert.io.
      </p>

      <h4 className="text-lg font-semibold mt-6 mb-2">VII. Kontakt</h4>
      <p>
        WeExpert sp. z o.o. – e-mail: info@weexpert.io; tel.: (uzupełnij);
        siedziba: (uzupełnij).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Regulamin serwisu WeExpert
      </h3>
      <p>
        Staraliśmy się spisać nasze zasady w sposób możliwie prosty; zawsze
        możesz przeczytać skróconą wersję Regulaminu (dostępna pod oddzielnym
        linkiem).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 1 – Definicje
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Administrator, WeExpert – WEEXPERT SP. Z O.O. z siedzibą we Wrocławiu,
          ul. Marsz. Józefa Piłsudskiego 74/320, 50-020 Wrocław, KRS:
          0000986528, NIP: 9671458021, REGON: 52278693000000; e-mail:
          info@weexpert.io.
        </li>
        <li>
          Serwis WeExpert / Serwis – serwis transakcji online o charakterze
          otwartym, prowadzony przez Administratora, służący do publikowania
          Ogłoszeń, zawierania umów dotyczących wykonania usług określonych w
          Serwisie i Ogłoszeniu oraz komunikacji między stronami transakcji;
          dostępny w domenie weexpert.io (wraz z subdomenami).
        </li>
        <li>
          Ogłoszenie – informacja umieszczana w Serwisie dotycząca
          zapotrzebowania na wykonanie usługi/czynności/dzieła lub zamiaru jej
          wykonania, zamieszczona przez Freelancera lub Zleceniodawcę w celu
          znalezienia kontrahenta.
        </li>
        <li>
          Zlecenie – zaakceptowany przez Freelancera i Zleceniodawcę zakres
          usługi/czynności/dzieła do wykonania wynikający z Ogłoszenia.
        </li>
        <li>
          Umowa – ustalenia pomiędzy Użytkownikami oraz z Administratorem w
          zakresie realizacji Zlecenia, określające prawa i obowiązki stron
          zgodnie z Regulaminem.
        </li>
        <li>
          Dzieło – efekt czynności wykonanych przez Freelancera po przyjęciu
          Zlecenia do realizacji.
        </li>
        <li>
          Użytkownik – osoba fizyczna, osoba prawna lub jednostka organizacyjna
          bez osobowości prawnej, korzystająca z usług WeExpert; może występować
          jako Zleceniodawca lub Freelancer.
        </li>
        <li>
          Freelancer – Użytkownik oferujący możliwość wykonania określonych
          usług/czynności/dzieł lub składający propozycję ich wykonania.
        </li>
        <li>Freelancer Krajowy – polski rezydent podatkowy.</li>
        <li>
          Freelancer Zagraniczny – niebędący polskim rezydentem podatkowym.
        </li>
        <li>
          Zleceniodawca – Użytkownik zamieszczający Ogłoszenie lub składający
          propozycję Zlecenia w odpowiedzi na Ogłoszenie Freelancera.
        </li>
        <li>
          Umowa o przeniesienie majątkowych praw autorskich / umowa licencyjna –
          ustalenia dotyczące przeniesienia praw autorskich lub udzielenia
          licencji do przedmiotu Zlecenia.
        </li>
        <li>
          Konto – zindywidualizowany zapis informatyczny utworzony w WeExpert na
          rzecz Użytkownika, chroniony loginem i hasłem.
        </li>
        <li>
          Płatności Online – usługi płatności internetowych; obsługiwane przez
          [dostawca płatności, Przelewy24/Stripe/inna].
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 2 – Postanowienia ogólne
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Regulamin określa zasady świadczenia przez WeExpert odpłatnych usług
          elektronicznych polegających na kojarzeniu Użytkowników, rozliczaniu
          transakcji, korzystaniu z Serwisu oraz świadczeniu usług dodatkowych.
        </li>
        <li>
          WeExpert ułatwia Użytkownikom poszukiwanie Freelancerów lub
          Zleceniodawców, określając prawa i obowiązki stron oraz zapewniając
          kanały komunikacji.
        </li>
        <li>
          WeExpert działa jako dostawca platformy internetowej łączący
          Freelancerów i Zleceniodawców, nie uczestniczy czynnie w realizacji
          usług/czynności/dzieł i nie ponosi odpowiedzialności za ich wykonanie.
        </li>
        <li>
          WeExpert może zlecać czynności podmiotom trzecim bez uprzedniej zgody
          stron; podmiot trzeci może być stroną umowy z Freelancerem.
        </li>
        <li>
          Użytkownicy, korzystając z Serwisu, składają oświadczenia
          elektroniczne, że:
          <ul className="list-disc pl-6 space-y-1">
            <li>akceptują Regulamin;</li>
            <li>
              przyjmują, że Regulamin kreuje prawa i obowiązki między
              Użytkownikami oraz z WeExpert;
            </li>
            <li>zapoznali się z Regulaminem i Polityką Ochrony Prywatności.</li>
          </ul>
        </li>
        <li>
          Złożenie powyższych oświadczeń warunkuje zakończenie rejestracji i
          zawarcie umowy o świadczenie usług z Administratorem.
        </li>
        <li>
          Oświadczenia są dobrowolne, wyraźne i jednoznaczne, składane przez
          checkbox lub potwierdzenie e-mail.
        </li>
        <li>
          Zleceniodawca ponosi odpowiedzialność wobec Freelancera w przypadku
          niewykonania/nienależytego wykonania Zlecenia; nie kieruje roszczeń
          wobec WeExpert ani podmiotów trzecich.
        </li>
        <li>
          Freelancer ponosi odpowiedzialność wobec Zleceniodawcy za wykonanie
          Zleceń i zgadza się na przekazanie danych/dokumentacji w celu
          dochodzenia roszczeń.
        </li>
      </ol>
      <h4 className="text-lg font-semibold mt-6 mb-2">
        2a. Obowiązki Freelancera i komunikacja
      </h4>
      <p>
        Freelancer oświadcza, że jeśli dla legalnego wykonania Zlecenia wymagane
        są uprawnienia/pozwolenia/licencje (zwłaszcza w zawodach regulowanych),
        podejmie Zlecenie wyłącznie posiadając wymagane uprawnienia. W
        przeciwnym wypadku wynagrodzenie nie przysługuje, a Zleceniodawca i
        WeExpert mogą dochodzić odszkodowania na zasadach ogólnych.
      </p>

      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Wszelka komunikacja między Użytkownikami związana z realizacją
          Ogłoszeń odbywa się poprzez wewnętrzne kanały Serwisu.
        </li>
        <li>
          Użytkownicy skojarzeni przez Serwis nie mogą rozliczać transakcji poza
          Serwisem. Naruszenie skutkuje odpowiedzialnością odszkodowawczą wobec
          WeExpert (w szczególności za utracone korzyści).
        </li>
        <li>
          Zakazane jest używanie kart/kont/rachunków bankowych osób trzecich (w
          tym członków rodziny/małżonków) do rozliczeń w Serwisie. Naruszenie
          może skutkować blokadą konta.
        </li>
        <li>
          Wysyłanie spamu/niezamówionych informacji handlowych do innych
          Użytkowników przez Serwis jest zabronione i może skutkować blokadą
          konta.
        </li>
        <li>
          Freelancer oświadcza, że Zlecenia będzie wykonywał zgodnie z prawem, w
          tym przepisami o ochronie danych i własności intelektualnej. Odpowiada
          odszkodowawczo wobec Zleceniodawcy w razie naruszeń.
        </li>
        <li>
          Jeśli na skutek wykonania Zlecenia ma dojść do przeniesienia praw
          autorskich lub udzielenia licencji niewyłącznej, Freelancer akceptując
          Regulamin, godzi się na przeniesienie/udzielenie licencji na warunkach
          Artykułu 5.
        </li>
        <li>
          Freelancer oświadcza, że po zbyciu majątkowych praw autorskich lub
          udzieleniu licencji nie będzie wykonywał autorskich praw osobistych w
          sposób ograniczający WeExpert lub Zleceniodawcę; wyraża zgodę na
          rozpowszechnianie utworu anonimowo.
        </li>
        <li>
          W razie roszczeń osób trzecich dotyczących naruszeń w związku z
          wykonanym Zleceniem lub jego wykorzystaniem, Freelancer zobowiązuje
          się niezwłocznie wesprzeć Zleceniodawcę (w tym przystąpić do sporu
          jako interwenient uboczny lub dostarczyć materiał dowodowy) oraz
          pokryć wszelkie szkody/koszty (w tym obsługi prawnej, odszkodowań,
          kosztów zasądzonych/ugód).
        </li>
        <li>
          Komunikacja między Administratorem a Użytkownikiem następuje przez
          wewnętrzne kanały Serwisu lub e-mail na adres podany przy rejestracji
          (albo adres pocztowy wskazany przez Użytkownika).
        </li>
        <li>
          Minimalne wymagania techniczne:
          <ul className="list-disc pl-6 space-y-1">
            <li>dostęp do Internetu;</li>
            <li>
              urządzenie umożliwiające wprowadzanie i odczyt danych
              elektronicznych;
            </li>
            <li>
              oprogramowanie do odczytu plików PDF, RTF, TXT, DOC, JPEG, AVI;
            </li>
            <li>
              przeglądarka: Edge/IE 11+, Firefox 57+, Chrome 62+ z włączonym
              JavaScript i cookies.
            </li>
          </ul>
        </li>
      </ol>
      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 3. Rejestracja
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Korzystanie ze wszystkich funkcjonalności Serwisu wymaga rejestracji.
        </li>
        <li>
          W imieniu osoby prawnej/jednostki organizacyjnej czynności w Serwisie
          może dokonać wyłącznie osoba należycie umocowana.
        </li>
        <li>
          Rejestracji dokonuje się przez wypełnienie formularza online
          udostępnianego przez WeExpert i akceptację Regulaminu.
        </li>
        <li>
          Po prawidłowych czynnościach Użytkownik otrzymuje automatyczne
          powiadomienie e-mail. Aktywacja Konta przez Administratora oznacza
          zawarcie umowy o świadczenie usług w Serwisie na zasadach Regulaminu.
        </li>
        <li>
          Użytkownik może odstąpić od umowy w ciągu 14 dni bez podania przyczyn,
          składając oświadczenie elektronicznie lub pisemnie (wystarczy wysłanie
          przed upływem terminu). Prawo odstąpienia nie przysługuje, jeżeli
          Użytkownik wykonał w Serwisie jakąkolwiek czynność (np. dodał
          Zlecenie/przyjął Zlecenie).
        </li>
        <li>
          Administrator może żądać udokumentowania danych podanych przez
          Użytkownika.
        </li>
        <li>
          Aktywacja Konta powoduje udostępnienie części danych Użytkownika na
          publicznie dostępnych stronach Serwisu.
        </li>
        <li>
          Dla osób fizycznych publicznie prezentowane są co najmniej imię i
          nazwisko oraz miejscowość zamieszkania; dla podmiotów niebędących
          osobami fizycznymi – firma (nazwa) oraz miejscowość
          siedziby/prowadzenia działalności. Dla Freelancerów prezentowany jest
          co najmniej 1 przykład zrealizowanych prac/dzieł/usług.
        </li>
        <li>
          Zmiana danych podanych przy rejestracji wymaga ich niezwłocznej
          aktualizacji w odpowiednim formularzu w Serwisie.
        </li>
        <li>
          Zabronione jest usuwanie/zniekształcanie danych w trakcie korzystania
          z Serwisu, podawanie danych niepełnych/nieprawdziwych.
        </li>
        <li>
          Zabronione jest posiadanie przez jednego Freelancera dwóch lub więcej
          Kont.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 4. Ogólne warunki wystawiania Ogłoszeń
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Administrator udostępnia narzędzia systemowe umożliwiające
          zamieszczanie Ogłoszeń oraz zawieranie Zleceń dotyczących przedmiotu
          Ogłoszenia, na zasadach Regulaminu.
        </li>
        <li>
          Ogłoszenie może zamieścić wyłącznie Użytkownik uprawniony do zawarcia
          umowy o treści określonej w Ogłoszeniu.
        </li>
        <li>
          Charakter uczestnictwa Administratora określa Artykuł 2.
          Administrator:
          <ul className="list-disc pl-6">
            <li>
              nie udziela rękojmi za wady (odpowiedzialność Administratora za
              wady jest wyłączona),
            </li>
            <li>
              nie gwarantuje prawidłowego wykonania Zlecenia ani posiadania
              przez Freelancera odpowiedniej wiedzy/umiejętności/doświadczenia.
            </li>
          </ul>
        </li>
        <li>
          Decyzje o publikacji Ogłoszenia, wyborze Freelancera i zawarciu
          Zlecenia Zleceniodawca podejmuje na własne ryzyko i koszt. Ewentualne
          roszczenia kieruje wyłącznie wobec Freelancera.
        </li>
        <li>
          Treść Ogłoszenia musi być rzetelna, kompletna i nie wprowadzać w błąd,
          w szczególności co do istoty i właściwości Zlecenia. Ogłoszenie
          powinno być możliwe do wyceny przez Freelancera i nie może zawierać
          danych kontaktowych Zleceniodawcy (kontakt wyłącznie przez komunikację
          WeExpert).
        </li>
        <li>
          Jeżeli w wyniku wykonania umowy ma powstać utwór w rozumieniu ustawy o
          prawie autorskim, Zleceniodawca wskazuje, czy żąda przeniesienia
          autorskich praw majątkowych do przedmiotu Zlecenia, czy udzielenia
          niewyłącznej licencji – na zasadach Artykułu 5.
        </li>
        <li>
          Ogłoszenie nie może zawierać wezwania do wysyłania bezpłatnych próbek
          prac.
        </li>
        <li>
          Ogłoszenie należy umieścić w odpowiedniej kategorii. Administrator
          może zmienić kategorię w razie błędnej kwalifikacji oraz skorygować
          treść w zakresie niezbędnych korekt
          stylistycznych/redakcyjnych/merytorycznych w granicach pkt 4.
        </li>
        <li>
          Użytkownik ponosi pełną odpowiedzialność za treści w Ogłoszeniu (w tym
          za błędy i nieścisłości).
        </li>
        <li>
          Ogłoszenie pochodzi od Użytkownika. Administrator co do zasady nie
          ingeruje w treść Ogłoszeń, z zastrzeżeniem pkt 7, 11 i innych
          postanowień Regulaminu.
        </li>
        <li>
          Treść Ogłoszenia (w tym jego przedmiot) nie może naruszać prawa, dóbr
          osobistych lub praw osób trzecich (w szczególności praw autorskich i
          własności intelektualnej), dobrych obyczajów ani wpływać negatywnie na
          dobre imię i renomę Administratora.
        </li>
        <li>
          Zabronione jest kopiowanie treści/materiałów (grafiki, dokumenty itp.)
          z Ogłoszeń w celu publikacji na zewnętrznych stronach.
        </li>
        <li>
          Administrator może ukrywać fragmenty Ogłoszeń lub usuwać Ogłoszenia w
          całości, jeżeli ich treść narusza Regulamin lub prawo.
        </li>
        <li>
          Zabronione są działania sztucznie zawyżające wiarygodność (np.
          symulowanie odpowiedzi/ofert/opinii), w tym przy użyciu innych Kont
          lub osób bliskich/współpracujących. Takie działania są zakazane i mogą
          skutkować sankcjami w Serwisie (w tym blokadą konta).
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 5. Prawa Autorskie
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Jeżeli wskutek wykonania Zlecenia między Zleceniodawcą a Freelancerem
          ma dojść do przeniesienia majątkowych praw autorskich do Dzieła lub
          udzielenia licencji niewyłącznej obejmującej korzystanie z Dzieła,
          Strony zawierają odpowiednio umowę o przeniesienie praw autorskich lub
          umowę licencyjną na warunkach niniejszego Artykułu. Niniejszy Artykuł
          określa także dokładne warunki przeniesienia majątkowych praw
          autorskich i udzielenia licencji.
        </li>
        <li>
          Do zawarcia umowy warunkowej pomiędzy Freelancerem a Podmiotem
          Powiązanym o przeniesienie majątkowych praw autorskich do Dzieła i
          wyłącznego prawa do zezwalania na wykonywanie zależnego prawa
          autorskiego dochodzi w momencie akceptacji niniejszego Regulaminu
          przez Freelancera – przy czym do przeniesienia praw autorskich
          dochodzi wyłącznie pod warunkiem zaistnienia okoliczności określonych
          w Artykule 7a pkt 2.
        </li>
        <li>
          Do zawarcia umowy o przeniesienie majątkowych praw autorskich do
          Dzieła i wyłącznego prawa do zezwalania na wykonywanie zależnego prawa
          autorskiego pomiędzy Administratorem a Zleceniodawcą dochodzi w
          momencie podpisania umowy przez każdą ze stron – przy czym umowa
          zostaje przesłana Zleceniodawcy dopiero w momencie akceptacji Zlecenia
          przez Zleceniodawcę, w sposób określony w niniejszym Regulaminie.
        </li>
        <li>
          Do zawarcia warunkowej umowy licencyjnej pomiędzy Freelancerem a
          Zleceniodawcą, obejmującej prawo do korzystania z przedmiotu Zlecenia,
          dochodzi w momencie akceptacji Regulaminu – przy czym do udzielenia
          licencji dochodzi wyłącznie pod warunkiem zaistnienia okoliczności
          określonych w Artykule 7b pkt 1.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 5a. Przeniesienie Majątkowych Praw Autorskich
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Freelancer przenosi na rzecz Podmiotu Powiązanego majątkowe prawa
          autorskie do Dzieła, a także wyłączne prawo do zezwalania na
          wykonywanie zależnego prawa autorskiego – w zakresie i na zasadach
          niniejszego Artykułu.
        </li>
        <li>
          Przeniesienie majątkowych praw autorskich oraz prawa wyłącznego do
          zezwalania na wykonywanie zależnego prawa autorskiego z Freelancera na
          Podmiot Powiązany następuje wyłącznie pod warunkiem akceptacji
          Zlecenia przez Zleceniodawcę w sposób określony w niniejszym
          Regulaminie.
        </li>
        <li>
          Przeniesienie autorskich prawa majątkowych nie jest ograniczone co do
          celu rozpowszechniania, czasu ani terytorium.
        </li>
        <li>Przeniesienie praw następuje nieodpłatnie.</li>
        <li>
          Przeniesienie autorskich praw majątkowych do Utworu obejmuje
          następujące pola eksploatacji:
          <ul className="list-disc pl-6 space-y-1">
            <li>
              trwałe lub czasowe utrwalanie lub zwielokrotnianie w całości lub w
              części, dowolnymi środkami i w jakiejkolwiek formie, niezależnie
              od formatów/systemów/standardów, w tym techniką drukarską, zapisu
              magnetycznego, cyfrową, poprzez wprowadzanie do pamięci komputera,
              sporządzanie kopii i dowolne korzystanie/rozporządzanie kopiami;
            </li>
            <li>
              stosowanie, wprowadzanie, wyświetlanie, przekazywanie i
              przechowywanie;
            </li>
            <li>użyczenie, najem, dzierżawa;</li>
            <li>
              publiczne rozpowszechnianie (wyświetlanie, odtwarzanie), nadawanie
              i reemitowanie w dowolnym systemie/standardzie oraz publiczne
              udostępnianie w taki sposób, aby każdy mógł mieć dostęp w miejscu
              i czasie przez siebie wybranym;
            </li>
            <li>wprowadzanie do pamięci komputera;</li>
            <li>rozpowszechnianie w Internecie oraz sieciach zamkniętych;</li>
            <li>
              nadawanie fonii/wizji bezprzewodowo (naziemnie, satelitarnie) lub
              przewodowo;
            </li>
            <li>
              opracowanie, przetwarzanie, wprowadzanie zmian, poprawek i
              modyfikacji Utworu;
            </li>
            <li>
              zezwolenie na tworzenie opracowań/przeróbek/modyfikacji, prawo do
              korzystania i rozporządzania nimi oraz udzielania licencji osobom
              trzecim;
            </li>
            <li>
              w przypadku programów komputerowych („Program”) lub serwisów
              internetowych („Serwis”): prawo do zwielokrotniania kodu lub
              dekompilacji, w tym opracowania i tłumaczenia formy kodu.
            </li>
          </ul>
        </li>
        <li>
          Wymienione pola eksploatacji dotyczą także utworów składających się na
          Dzieło powstałe wskutek wykonanego Zlecenia.
        </li>
        <li>
          Podmiot Powiązany jest uprawniony i zobowiązany do dalszego
          przekazania praw autorskich do Dzieła na rzecz Administratora, bez
          zgody Freelancera i bez dodatkowego wynagrodzenia na rzecz
          Zleceniodawcy.
        </li>
        <li>
          Do przeniesienia praw autorskich z Podmiotu Powiązanego na
          Administratora dochodzi na podstawie odrębnego postanowienia, a samo
          przeniesienie praw następuje w momencie akceptacji Zlecenia przez
          Zleceniodawcę. Przeniesienie obejmuje wszystkie nabyte wcześniej prawa
          (w zakresie wszystkich pól eksploatacji z pkt 5), a także wyłączne
          prawo do zezwalania na wykonywanie zależnego prawa autorskiego.
        </li>
        <li>
          Administrator przenosi na rzecz Zleceniodawcy majątkowe prawa
          autorskie, a także wyłączne prawo do zezwalania na wykonywanie
          zależnego prawa autorskiego – w szczególności w zakresie pól
          eksploatacji wymienionych w pkt 13 niniejszego Artykułu.
        </li>
        <li>
          Przeniesienie majątkowych praw autorskich z Administratora na
          Zleceniodawcę następuje w momencie podpisania przez każdą ze stron
          Umowy o przeniesienie majątkowych praw autorskich i pod warunkiem
          wcześniejszej akceptacji Zlecenia.
        </li>
        <li>
          Przeniesienie autorskich praw majątkowych nie jest ograniczone co do
          celu rozpowszechniania, czasu ani terytorium.
        </li>
        <li>Przeniesienie praw następuje nieodpłatnie.</li>
        <li>
          Przeniesienie praw autorskich obejmuje pola eksploatacji jak w pkt 5
          (utrwalanie/zwielokrotnianie, korzystanie z kopii, stosowanie,
          użyczenie, publiczne udostępnianie, opracowania, licencje dla osób
          trzecich, w tym Program/Serwis).
        </li>
        <li>
          Wymienione pola eksploatacji dotyczą także utworów składających się na
          Dzieło powstałe wskutek wykonanego Zlecenia.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">Artykuł 5b. Licencje</h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Udzielenie przez Freelancera licencji niewyłącznej, obejmującej
          nadanie Zleceniodawcy prawa do korzystania z przedmiotu Zlecenia,
          następuje wyłącznie pod warunkiem akceptacji Zlecenia przez
          Zleceniodawcę w sposób określony w niniejszym Regulaminie.
        </li>
        <li>
          Freelancer udziela Zleceniodawcy licencji niewyłącznej obejmującej
          prawo do korzystania z przedmiotu Zlecenia na następujących polach
          eksploatacji:
          <ul className="list-disc pl-6 space-y-1">
            <li>
              utrwalenia i zwielokrotnienia dowolną techniką, w dowolnie
              wybranej formie, w dowolnej liczbie egzemplarzy, w tym techniką
              fotograficzną, drukarską, reprograficzną, zapisu magnetycznego,
              cyfrowego, a także rozpowszechnianie zwielokrotnionych kopii;
            </li>
            <li>
              wprowadzania do obrotu, oddawania w nieodpłatne użyczenie utworu
              lub najmu oryginału albo fragmentów, w tym łączenie fragmentów
              różnych utworów tworzących jedną całość, wykorzystywanie w
              prezentacjach, konferencjach, eventach, mailingu – w tym
              komercjalizacja;
            </li>
            <li>
              wprowadzania do pamięci komputerów lub innych urządzeń
              elektronicznych, w tym mobilnych i cloud computing;
            </li>
            <li>
              publicznego wykonania, wystawienia, wyświetlenia, odtworzenia,
              nadawania i reemitowania oraz publicznego udostępniania;
            </li>
            <li>wprowadzania i udostępniania w sieciach Internet, Intranet;</li>
            <li>
              wprowadzania i udostępniania w sieciach telekomunikacyjnych i
              informatycznych (np. SMS, MMS, EMS, IVR, WAP, VPN);
            </li>
            <li>
              rozpowszechniania w publikacjach periodycznych i nieperiodycznych,
              w tym dziennikach, tygodnikach, czasopismach, serwisach
              agencyjnych, biuletynach, programach radiowych i telewizyjnych;
            </li>
            <li>
              rozpowszechniania w ogólnie dostępnych bankach utworów, w tym
              bankach zdjęć w Internecie;
            </li>
            <li>
              rozpowszechniania za pomocą technologii na żądanie (pay per view,
              on demand) zarówno odpłatnie, jak i nieodpłatnie;
            </li>
            <li>
              łączenia całości i fragmentów z innymi utworami tworząc jednorodne
              opracowanie;
            </li>
            <li>
              nadawania za pomocą wizji lub fonii przewodowej i bezprzewodowej,
              satelity i innych form ogólnego przekazu;
            </li>
            <li>
              współautorskiego wydania zbiorowego (książki, albumy, katalogi,
              leksykony, kalendarze, wydawnictwa multimedialne, utwory
              audiowizualne);
            </li>
            <li>
              w odniesieniu do programów komputerowych – dokonywania dowolnych
              zmian w programie i jego kodzie źródłowym (tłumaczenia,
              przystosowania, zmiany układu – opracowanie);
            </li>
            <li>
              wykorzystania w innych utworach w postaci nie stanowiącej
              opracowania, w tym w utworach audiowizualnych lub multimedialnych.
            </li>
          </ul>
        </li>
        <li>
          Freelancer udziela Zleceniodawcy zezwolenia na rozporządzanie i
          korzystanie z opracowania utworu poprzez tłumaczenie, modyfikację,
          adaptację, uzupełnienia lub uszczegółowienia utworu pierwotnego
          (zależne prawa autorskie). Jeżeli elementem utworu jest baza danych,
          zezwolenie obejmuje także sporządzenie jej opracowania.
        </li>
        <li>
          Licencja obejmuje prawo do udzielenia dalszej licencji (sublicencji)
          na korzystanie z przedmiotu Zlecenia. Licencji udziela się na okres 15
          lat.
        </li>
      </ol>
      <h3 className="text-xl font-semibold mt-10 mb-4">Artykuł 6. Opłaty</h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Część usług w ramach Serwisu WeExpert świadczonych jest odpłatnie.
        </li>
        <li>
          Podstawową opłatą z tytułu realizacji usług określonych niniejszą
          umową jest prowizja (wynagrodzenie Administratora), o której mowa w
          załączniku nr 3 do niniejszego Regulaminu.
        </li>
        <li>
          Podmioty prowadzące działalność gospodarczą (osoby fizyczne, osoby
          prawne, jednostki organizacyjne nieposiadające osobowości prawnej)
          będące Freelancerami mogą wykupić abonament w ramach Serwisu
          uprawniający do składania Propozycji Wykonania Ogłoszenia.
        </li>
        <li>
          Wysokość innych opłat za pozostałe usługi, do których Użytkownicy mogą
          mieć dostęp w związku z działaniem Serwisu WeExpert (np. rozliczenie
          płatności online, przesłanie faktury VAT pocztą w formie papierowej,
          wybór sposobu rozliczenia transakcji, opłaty abonamentowe) określa
          załącznik do niniejszego Regulaminu.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 7. Inne postanowienia Regulaminu
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          WeExpert nie ponosi odpowiedzialności za działania Użytkowników w
          ramach Serwisu ani za nienależyte wykonanie bądź niewykonanie przez
          nich zobowiązań związanych z Ogłoszeniem bądź Zleceniem, podanie przez
          Użytkowników nieprawdziwych lub niepełnych informacji w Ogłoszeniu lub
          Zleceniu, jak również za następstwa działań podjętych przez
          Użytkowników oraz osoby trzecie, a stanowiących naruszenie postanowień
          Regulaminu.
        </li>
        <li>
          WeExpert nie ponosi odpowiedzialności za prawdziwość i rzetelność
          informacji podawanych przez Użytkowników, a także zdolność
          Użytkowników do zawarcia i realizacji umowy.
        </li>
        <li>
          WeExpert zastrzega sobie prawo do usunięcia Ogłoszenia lub Zlecenia
          albo zablokowania Konta w przypadku naruszania przez Użytkownika
          postanowień Regulaminu, przepisów prawa, dobrych obyczajów lub zasad
          współżycia społecznego. Zrealizowane Zlecenie, w którym doszło do
          naruszenia Regulaminu przez Użytkownika, zostanie oznaczone jako
          „Sporne”.
        </li>
        <li>
          W przypadku blokady Konta wszystkie opublikowane przez Użytkownika
          Ogłoszenia zostają automatycznie usunięte, a Użytkownik nie może
          korzystać z żadnych usług świadczonych przez WeExpert w ramach
          Serwisu.
        </li>
        <li>
          W przypadku gdy Użytkownik uważa, iż konto zostało zablokowane przez
          pomyłkę bądź niezasadnie, jest uprawniony do złożenia odwołania.
          Odwołania należy zgłaszać do WeExpert na adres info@weexpert.io lub
          pisemnie listem poleconym na adres siedziby Administratora wskazany w
          Serwisie. Odwołanie powinno zawierać dane Użytkownika (imię, nazwisko,
          adres korespondencyjny, adres e-mail i numer telefonu), a także
          okoliczności lub materiały uzasadniające odwołanie.
        </li>
        <li>
          Odwołania będą rozpatrywane niezwłocznie, nie później niż w terminie 7
          dni od dnia ich otrzymania. O sposobie rozpatrzenia odwołania
          Użytkownik zostanie poinformowany za pomocą poczty e-mail.
        </li>
        <li>
          Zakazane jest umieszczanie w Ogłoszeniu lub Zleceniu treści o
          charakterze bezprawnym. WeExpert ma prawo do usunięcia lub edycji
          Ogłoszenia lub Zlecenia, jeżeli narusza ono w jakikolwiek sposób
          postanowienia Regulaminu lub przepisy prawa, w szczególności gdy
          zawiera treści:
          <ul className="list-disc pl-6 space-y-1">
            <li>powszechnie uznane za obraźliwe,</li>
            <li>noszące znamiona czynów nieuczciwej konkurencji,</li>
            <li>
              naruszające dobre obyczaje, prawa autorskie lub inne prawa
              własności intelektualnej,
            </li>
            <li>wprowadzające w błąd.</li>
          </ul>
        </li>
        <li>
          WeExpert zastrzega sobie prawo do umieszczania logo lub nazwy
          Użytkowników w Serwisie, w tym m.in. w sekcji „Nasi Klienci” lub innej
          sekcji informującej o osobach lub firmach korzystających z usług
          Serwisu. Ponadto, WeExpert zastrzega sobie prawo do umieszczania w
          Serwisie innych informacji dotyczących Zleceniodawców i Freelancerów,
          w tym m.in. opisu profilu działalności i liczby zleceń zrealizowanych
          za pośrednictwem Serwisu WeExpert, przy czym umieszczenie tych
          informacji może mieć charakter zarówno informacyjny, jak i reklamowy.
        </li>
        <li>
          W przypadku gdy Zleceniodawca zamówi usługę wysyłki dokumentów pocztą,
          usługa ta realizowana będzie w terminie 5 dni od dnia dokonania
          płatności za tę usługę w wysokości określonej w Regulaminie.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 8. Umowy Sporne
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Rozpatrywanie i rozwiązywanie zleceń spornych. WeExpert nie ponosi
          odpowiedzialności za działania Użytkowników w ramach Serwisu, w tym za
          niewykonanie bądź nienależyte wykonanie dzieła przez Freelancera.
          Jednocześnie, w ramach wsparcia, rozpatrujemy i przedstawiamy
          rekomendowane formy rozwiązania ewentualnych sporów pomiędzy
          Użytkownikami, na zasadach określonych poniżej w pkt 2–5.
        </li>
        <li>
          Zgodność pliku/dokumentu z treścią zlecenia. Podczas rozpatrywania
          zleceń spornych bierzemy pod uwagę zgodność pliku/dokumentu,
          dostarczonego za pomocą narzędzi Serwisu WeExpert, z treścią zlecenia.
          W pierwszej kolejności weryfikujemy, czy plik/dokument jest zgodny z
          tytułem umowy oraz opisem zlecenia. Sprawdzenie zgodności jest
          dokonywane wyłącznie w oparciu o faktyczną i literalną ocenę treści.
          Jeżeli stwierdzimy zgodność dzieła z tytułem i opisem, przystępujemy
          do wypłaty wynagrodzenia Freelancerowi.
        </li>
        <li>
          Jeśli, w oparciu o tytuł i/lub opis zlecenia, nie jesteśmy w stanie
          jednoznacznie ustalić zgodności dostarczonego pliku/dokumentu,
          dodatkowo bierzemy pod uwagę informacje i uzgodnienia zawarte w
          wiadomościach wysyłanych przez strony umowy za pośrednictwem
          wewnętrznego komunikatora WeExpert.
        </li>
        <li>
          Nie bierzemy pod uwagę informacji i uzgodnień zawartych poza Platformą
          WeExpert (np. e-mail, WhatsApp, Messenger).
        </li>
        <li>
          Nie dokonujemy merytorycznej oceny wykonanego Dzieła (parametrów
          technicznych, estetycznych, funkcjonalnych itp.) – weryfikujemy
          wyłącznie zgodność z zakresem ustalonym w zleceniu.
        </li>
        <li>
          Jeżeli nie jesteśmy w stanie rozstrzygnąć sporu w ramach zlecenia
          spornego na podstawie powyższych kryteriów, niezwłocznie informujemy o
          tym strony i przedstawiamy rekomendowane formy rozwiązania sporu:
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Poprawki w Dziele – zakres i termin poprawek ustalają strony
              bezpośrednio. Informacja o ustaleniach musi zostać niezwłocznie
              przekazana do WeExpert.
            </li>
            <li>
              Zmiana stawki wynagrodzenia – strony uzgadniają nową kwotę;
              ustalenia należy niezwłocznie przekazać do WeExpert.
            </li>
            <li>
              Wypłata 50/50 – automatyczne obniżenie stawki do 50% pierwotnie
              uzgodnionego wynagrodzenia.
            </li>
          </ul>
        </li>
        <li>
          Strony mają 7 dni na podjęcie jednomyślnej decyzji co do preferowanej
          formy rozwiązania sporu i poinformowanie WeExpert drogą mailową na
          info@weexpert.io.
        </li>
        <li>
          Jeżeli w terminie 7 dni strony nie poinformują WeExpert o jednomyślnej
          decyzji, rozliczymy umowę w oparciu o rozwiązanie „Wypłata 50/50”.
          Jednocześnie udzielimy stronom pełnego dostępu do dokumentów i
          informacji związanych z realizacją spornego zlecenia, w celu
          umożliwienia dalszego dochodzenia swoich praw na drodze sądowej
          (kontakt: info@weexpert.io).
        </li>
        <li>
          Jeżeli strony nie są zainteresowane żadnym z rekomendowanych
          rozwiązań, mogą – w terminie 7 dni od przedstawienia rekomendacji –
          poinformować nas o zamiarze poddania sporu pod rozstrzygnięcie
          wybranego przez siebie mediatora lub rzeczoznawcy. Strony pokrywają
          koszty tej procedury. Na prośbę stron udzielimy dostępu do dokumentów
          i informacji związanych ze zleceniem.
        </li>
        <li>
          W przypadku skorzystania z mediatora lub rzeczoznawcy, WeExpert jest
          uprawniony do zabezpieczenia płatności do czasu przedstawienia
          ostatecznego stanowiska rozstrzygającego spór między Freelancerem i
          Zleceniodawcą.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 9. Postępowanie reklamacyjne
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Użytkownik ma prawo zgłaszać reklamacje niewykonania bądź
          nienależytego wykonania przez WeExpert usług w ramach Serwisu WeExpert
          w terminie 7 dni od dnia zakończenia publikacji Ogłoszenia bądź dnia
          zakończenia realizacji Zlecenia. Jeżeli reklamacja dotyczy innych
          obszarów niż publikacja Ogłoszenia bądź realizacja Zlecenia,
          reklamacja powinna zostać złożona w terminie 7 dni od dnia wystąpienia
          zdarzenia stanowiącego podstawę reklamacji.
        </li>
        <li>
          Reklamacje należy zgłaszać na adres info@weexpert.io lub pisemnie
          listem poleconym na adres siedziby Administratora wskazany w Serwisie.
          O terminie złożenia reklamacji pisemnie decyduje data nadania
          przesyłki.
        </li>
        <li>
          Reklamacja powinna zawierać dane Użytkownika (imię, nazwisko, adres
          korespondencyjny, adres e-mail i numer telefonu), numer Ogłoszenia
          bądź Zlecenia (jeśli nadany) lub inne dane pozwalające na
          identyfikację zdarzenia, a także okoliczności lub materiały
          uzasadniające reklamację.
        </li>
        <li>
          Reklamacje będą rozpatrywane niezwłocznie, nie później niż w ciągu 10
          dni roboczych od dnia otrzymania kompletu informacji pozwalających na
          rozstrzygnięcie reklamacji.
        </li>
        <li>
          Jeżeli podane przez Użytkownika dane wymagają uzupełnienia, WeExpert
          zwróci się o ich wskazanie w zakreślonym terminie.
        </li>
        <li>
          Jeżeli rozpatrzenie reklamacji nie będzie możliwe w terminie, o którym
          mowa powyżej, WeExpert zawiadomi Użytkownika, wskazując przewidywany
          termin jej rozpatrzenia.
        </li>
        <li>
          O rozstrzygnięciu reklamacji Użytkownik zostanie powiadomiony drogą
          e-mail na adres zarejestrowany w Serwisie WeExpert.
        </li>
      </ol>
      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 10. Pozasądowe sposoby rozpatrywania reklamacji i dochodzenia
        roszczeń oraz zasady dostępu do tych procedur
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Skorzystanie z pozasądowych sposobów rozpatrywania reklamacji i
          dochodzenia roszczeń ma charakter dobrowolny. Postanowienia
          niniejszego artykułu mają charakter informacyjny i nie zobowiązują
          Użytkownika do skorzystania z pozasądowych sposobów rozwiązywania
          sporów.
        </li>
        <li>
          Zasady prowadzenia postępowań w sprawie pozasądowego rozwiązywania
          sporów konsumenckich oraz obowiązki przedsiębiorców w tym zakresie
          określa ustawa z dnia 23 września 2016 r. o pozasądowym rozwiązywaniu
          sporów konsumenckich. Prezes UOKiK prowadzi jawny rejestr podmiotów
          uprawnionych do prowadzenia takich postępowań.
        </li>
        <li>
          Użytkownik będący konsumentem może w szczególności:
          <ul className="list-disc pl-6 space-y-1">
            <li>
              zwrócić się o rozstrzygnięcie sporu do stałego polubownego sądu
              konsumenckiego (art. 37 ustawy z dnia 15 grudnia 2000 r. o
              Inspekcji Handlowej; regulamin określa rozporządzenie Ministra
              Sprawiedliwości z 25 września 2001 r.),
            </li>
            <li>
              wystąpić z wnioskiem o wszczęcie postępowania do wojewódzkiego
              inspektora Inspekcji Handlowej (art. 36 ww. ustawy),
            </li>
          </ul>
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 11. Rozwiązanie umowy
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Umowa o świadczenie usług w ramach Serwisu WeExpert jest zawierana na
          czas nieoznaczony w języku polskim.
        </li>
        <li>
          Użytkownik może w każdym czasie rozwiązać z WeExpert umowę o
          świadczenie usług w ramach Serwisu, poprzez wysłanie na adres
          info@weexpert.io wiadomości e-mail lub pisemnego oświadczenia na adres
          siedziby Administratora wskazany w Serwisie, zawierającego
          oświadczenie o rozwiązaniu umowy ze wskazaniem danych identyfikujących
          Konto.
        </li>
        <li>
          Umowa ulega rozwiązaniu ze skutkiem natychmiastowym, chyba że
          Użytkownik posiada aktualne Ogłoszenie bądź jest w trakcie realizacji
          Zlecenia. W takim wypadku umowa ulega rozwiązaniu po upływie 30 dni od
          zakończenia publikacji Ogłoszenia bądź od zakończenia realizacji
          Zlecenia.
        </li>
        <li>
          WeExpert zastrzega sobie prawo do rozwiązania umowy z Użytkownikiem,
          który narusza postanowienia Regulaminu.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 12. Odstąpienie od umowy
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Użytkownikowi będącemu konsumentem przysługuje prawo do odstąpienia od
          umowy o świadczenie usług w ramach Serwisu WeExpert w terminie 14 dni,
          bez podawania przyczyn i bez ponoszenia kosztów innych niż
          przewidziane przepisami prawa – na warunkach określonych poniżej.
        </li>
        <li>
          Odstąpienie może nastąpić poprzez złożenie Administratorowi
          oświadczenia o odstąpieniu od umowy. Szczegółowe informacje określa
          pouczenie o odstąpieniu od umowy (załącznik nr 1 do Regulaminu).
          Oświadczenie można złożyć z wykorzystaniem wzoru formularza (załącznik
          nr 2) lub w innej jednoznacznej formie.
        </li>
        <li>
          Oświadczenia o odstąpieniu przesyłane e-mailem należy kierować na
          info@weexpert.io. Oświadczenia pisemne, złożone za pośrednictwem
          tradycyjnej poczty, należy wysłać na adres siedziby Administratora
          wskazany w Serwisie. Do zachowania terminu wystarczy wysłanie
          oświadczenia przed jego upływem.
        </li>
        <li>
          Termin 14 dni do odstąpienia od umowy biegnie od dnia jej zawarcia.
        </li>
        <li>
          Prawo do odstąpienia nie przysługuje konsumentowi w odniesieniu do
          umów:
          <ul className="list-disc pl-6 space-y-1">
            <li>
              o świadczenie usług, jeżeli Administrator wykonał w pełni usługę
              za wyraźną zgodą Użytkownika, który został poinformowany przed
              rozpoczęciem świadczenia, że po spełnieniu świadczenia utraci
              prawo odstąpienia;
            </li>
            <li>
              o dostarczanie treści cyfrowych, które nie są zapisane na nośniku
              materialnym, jeżeli spełnianie świadczenia rozpoczęło się za
              wyraźną zgodą konsumenta przed upływem terminu do odstąpienia oraz
              po poinformowaniu go o utracie prawa odstąpienia.
            </li>
          </ul>
        </li>
        <li>
          Pod pojęciem „konsumenta” rozumie się konsumenta oraz inne osoby, do
          których stosuje się przepisy o konsumentach.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 13. Zmiany Regulaminu
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          WeExpert może zmienić Regulamin i uruchomić nową wersję usług
          świadczonych w ramach Serwisu WeExpert. Zmiana staje się skuteczna w
          terminie wskazanym przez WeExpert, który nie może być krótszy niż 7
          dni od momentu udostępnienia w Serwisie zmienionego Regulaminu i
          zaakceptowania go przez Użytkownika. Ogłoszenia oraz Zlecenia
          opublikowane przed wejściem w życie zmian realizowane są na zasadach
          dotychczasowych.
        </li>
        <li>
          Użytkownik przy pierwszym logowaniu w Serwisie WeExpert po
          udostępnieniu zmienionego Regulaminu zostanie powiadomiony o tych
          zmianach i o możliwości ich akceptacji. Odmowa akceptacji zmian jest
          równoznaczna z rozwiązaniem umowy z WeExpert w ramach Serwisu
          WeExpert.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 14. Płatności
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          W przypadku konieczności zwrotu środków za transakcję dokonaną przez
          Użytkownika kartą płatniczą, sprzedawca dokona zwrotu na rachunek
          bankowy przypisany do karty płatniczej Użytkownika.
        </li>
        <li>
          Czas realizacji zamówienia Płatności Online liczony jest od momentu
          uzyskania pozytywnej autoryzacji płatności.
        </li>
        <li>
          Użytkownikowi przysługuje prawo odstąpienia od umowy w ramach
          Płatności Online w terminie 14 dni od dnia zawarcia umowy.
        </li>
        <li>
          Informacja „Obsługiwane banki” – aktualna lista banków/metod płatności
          jest prezentowana w trakcie procesu płatności i może ulegać zmianom po
          stronie dostawcy Płatności.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 15. Końcowe postanowienia Regulaminu
      </h3>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Prawem właściwym dla umowy pomiędzy Użytkownikiem a WeExpert, której
          przedmiotem są usługi świadczone w ramach Serwisu WeExpert na
          warunkach określonych w Regulaminie, jest prawo polskie.
        </li>
        <li>
          Prawo polskie jest również właściwe dla stosunków prawnych pomiędzy
          Zleceniodawcą a Freelancerem wynikających z niniejszego Regulaminu
          oraz z realizacji Zleceń za pomocą Serwisu WeExpert, na co strony
          wyrażają zgodę.
        </li>
        <li>
          Prawem właściwym dla umów pomiędzy Freelancerami a WeExpert , których
          przedmiotem jest przeniesienie majątkowych praw autorskich do utworu i
          wyłącznych praw do zezwalania na wykonywanie zależnego prawa
          autorskiego do utworu na warunkach określonych w niniejszym
          Regulaminie, jest prawo estońskie.
        </li>
        <li>
          Wszelkie spory związane z usługami świadczonymi przez WeExpert w
          ramach Serwisu będą rozstrzygane przez właściwe polskie sądy
          powszechne.
        </li>
        <li>
          W przypadku rozbieżności w interpretacji zapisów niniejszego
          Regulaminu sporządzonego w różnych wersjach językowych, wiążąca dla
          stron jest wersja w języku polskim, a w przypadku jej braku – wersja
          angielskojęzyczna.
        </li>
        <li>
          Jeżeli którekolwiek z postanowień Regulaminu zostanie uznane
          prawomocnym orzeczeniem sądu za nieważne, pozostałe postanowienia
          pozostają w mocy. W miejsce postanowienia nieważnego wprowadzone
          zostanie postanowienie odpowiadające jak najbardziej zgodnemu
          zamiarowi stron.
        </li>
        <li>
          Integralną częścią Regulaminu jest załącznik – tabela opłat w systemie
          WeExpert.
        </li>
      </ol>

      <div className="space-y-6">
        <h3 className="text-xl font-semibold mt-10 mb-4">
          Załączniki do Regulaminu (WeExpert)
        </h3>
        <ul className="list-disc pl-6 space-y-1">
          <li>Załącznik nr 1 – Wzór pouczenia o odstąpieniu od umowy</li>
          <li>Załącznik nr 2 – Wzór formularza odstąpienia od umowy</li>
          <li>Załącznik nr 3 – Cennik (tabela opłat)</li>
          <li>Polityka prywatności</li>
        </ul>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Regulamin WeExpert – wersja skrócona
        </h3>
        <p className="font-semibold">NAJWAŻNIEJSZE POSTANOWIENIA REGULAMINU</p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 1 – Definicje
        </h3>
        <p>
          Tu poznasz wszystkie określenia używane w Regulaminie i w serwisie.
          Dowiesz się, czym jest ogłoszenie, zlecenie, umowa i dzieło, kto jest
          administratorem serwisu oraz jakie funkcje są dostępne dla
          Użytkowników (osób zalogowanych).
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 2 – Postanowienia ogólne
        </h3>
        <p>
          Jak działa serwis, zakres odpowiedzialności Twojej i WeExpert oraz
          Twoje prawa i obowiązki wobec serwisu. Ważne:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Jako Freelancer bierzesz pełną odpowiedzialność za wykonane dzieło.
          </li>
          <li>
            Jako Zleceniodawca nie możesz wymagać od WeExpert
            dostarczenia/wykonania pracy – to zadanie Freelancera.
          </li>
          <li>
            WeExpert to platforma pośrednicząca; spory z umów rozwiązują między
            sobą Zleceniodawca i Freelancer (WeExpert może, ale nie musi,
            pomagać).
          </li>
          <li>
            WeExpert może udostępnić dane Freelancera Zleceniodawcy, jeżeli
            dojdzie do sporu sądowego w związku z umową zawartą przez serwis.
          </li>
          <li>
            Zakazane jest rozliczanie poza platformą (np. podawanie prywatnego
            numeru konta). Skutkuje to natychmiastową blokadą konta i
            dochodzeniem odszkodowania.
          </li>
          <li>
            Spam i nachalne reklamy są niedozwolone i skutkują blokadą konta.
          </li>
        </ul>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 3 – Rejestracja
        </h3>
        <p>
          Zakładając konto, akceptujesz Regulamin. Podanie nieprawdziwych danych
          obciąża Ciebie. WeExpert może poprosić o potwierdzenie danych. Możesz
          wycofać rejestrację i poprosić o usunięcie danych: info@weexpert.io.
          Jako Freelancer możesz mieć tylko jedno konto.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 4 – Ogólne warunki wystawiania Ogłoszeń
        </h3>
        <p>
          Ogłoszenia muszą być zgodne z prawem i Regulaminem oraz nie mogą
          zawierać prywatnych danych kontaktowych Zleceniodawcy ani wezwań do
          wysyłania darmowych próbek. Ogłoszenia są moderowane; mogą zostać
          edytowane lub usunięte, jeśli naruszają przepisy/regulamin.
        </p>
        <p>
          Nie wolno kopiować treści Ogłoszeń do innych serwisów. Freelancer nie
          może składać ofert tylko po to, by „podbijać statystyki”.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 5 – Licencje
        </h3>
        <p>
          Freelancer może udzielić licencji niewyłącznej na korzystanie z
          przedmiotu zlecenia (utrwalanie, kopiowanie, rozpowszechnianie,
          komercjalizacja – zgodnie z pełną wersją Regulaminu).
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">Artykuł 6 – Opłaty</h3>
        <p>
          Większość funkcji jest bezpłatna. Stała opłata to prowizja serwisu (wg
          Cennika). Usługi dodatkowo płatne obejmują m.in. wystawienie faktury
          VAT bez pro formy, wysyłkę papierowej faktury i korzystanie z szybkich
          płatności online. Szczegóły w Załączniku – Cennik.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 7 – Inne postanowienia
        </h3>
        <p>
          WeExpert nie odpowiada za działania Użytkowników. Możemy usunąć
          Ogłoszenie/Zlecenie i zablokować lub usunąć konto w razie naruszeń
          prawa/Regulaminu/dobrych obyczajów. Blokada usuwa też złożone oferty i
          opublikowane zlecenia.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 8 – Umowy sporne
        </h3>
        <p>
          WeExpert nie odpowiada za niewykonanie/nienależyte wykonanie dzieła
          przez Użytkowników. Wspieramy strony, przedstawiając rekomendowane
          sposoby rozwiązania sporu (opis w pełnym Regulaminie).
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuły 9-10 – Reklamacje i ADR
        </h3>
        <p>
          Reklamacje usług WeExpert: info@weexpert.io (imię i nazwisko, adres
          korespondencyjny, e-mail konta, telefon, numer Ogłoszenia/Zlecenia i
          materiał do reklamacji). Czas na odpowiedź: do 10 dni roboczych (z
          możliwością wydłużenia – informujemy o tym). Możesz skorzystać z
          pozasądowych metod rozwiązywania sporów (ADR) opisanych w Regulaminie.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuły 11-12 – Rozwiązanie i odstąpienie
        </h3>
        <p>
          Możesz w każdej chwili rozwiązać umowę z serwisem/odstąpić i skasować
          konto: info@weexpert.io. Jeżeli nie było umów – usuwamy konto i dane.
          Jeżeli były – dane przechowujemy przez 5 lat (wymogi prawa). Po
          usunięciu konta nie zalogujesz się dotychczasowymi danymi.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 13 – Zmiany Regulaminu
        </h3>
        <p>
          WeExpert może zmienić Regulamin; poinformujemy o tym w serwisie. Brak
          akceptacji zmian = brak możliwości dalszego korzystania.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 14 – Płatności
        </h3>
        <p>
          Ten punkt wskazuje operatora płatności online, dostępne karty i zasady
          zwrotów/reklamacji transakcji online.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Artykuł 15 – Postanowienia końcowe
        </h3>
        <p>
          Działamy zgodnie z prawem polskim; spory z umów między Zleceniodawcą a
          Freelancerem rozstrzygają polskie sądy powszechne. Wersja prawnie
          wiążąca: polska (a w razie braku – angielska).
        </p>
        <p className="font-semibold">
          Uwaga: To wersja skrócona – nie stanowi Regulaminu w sensie prawnym.
        </p>
        <p>
          Przejdź do pełnej wersji Regulaminu:{" "}
          <a href="#" className="text-blue-600 underline">
            weexpert.io
          </a>
        </p>
      </div>
      <h3 className="text-xl font-semibold mt-10 mb-4">
        Załączniki do Regulaminu (WeExpert)
      </h3>
      <ul className="list-disc pl-6 space-y-1">
        <li>Załącznik nr 1 – Wzór pouczenia o odstąpieniu od umowy</li>
        <li>Załącznik nr 2 – Wzór formularza odstąpienia od umowy</li>
        <li>Załącznik nr 3 – Cennik (tabela opłat)</li>
        <li>Polityka prywatności</li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Regulamin WeExpert – wersja skrócona
      </h3>
      <p className="font-semibold">NAJWAŻNIEJSZE POSTANOWIENIA REGULAMINU</p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 1 – Definicje
      </h3>
      <p>
        Tu poznasz wszystkie określenia używane w Regulaminie i w serwisie.
        Dowiesz się, czym jest ogłoszenie, zlecenie, umowa i dzieło, kto jest
        administratorem serwisu oraz jakie funkcje są dostępne dla Użytkowników
        (osób zalogowanych).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 2 – Postanowienia ogólne
      </h3>
      <p>
        Jak działa serwis, zakres odpowiedzialności Twojej i WeExpert oraz Twoje
        prawa i obowiązki wobec serwisu. Ważne:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Jako Freelancer bierzesz pełną odpowiedzialność za wykonane dzieło.
        </li>
        <li>
          Jako Zleceniodawca nie możesz wymagać od WeExpert
          dostarczenia/wykonania pracy – to zadanie Freelancera.
        </li>
        <li>
          WeExpert to platforma pośrednicząca; spory z umów rozwiązują między
          sobą Zleceniodawca i Freelancer (WeExpert może, ale nie musi,
          pomagać).
        </li>
        <li>
          WeExpert może udostępnić dane Freelancera Zleceniodawcy, jeżeli
          dojdzie do sporu sądowego w związku z umową zawartą przez serwis.
        </li>
        <li>
          Zakazane jest rozliczanie poza platformą (np. podawanie prywatnego
          numeru konta). Skutkuje to natychmiastową blokadą konta i dochodzeniem
          odszkodowania.
        </li>
        <li>
          Spam i nachalne reklamy są niedozwolone i skutkują blokadą konta.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 3 – Rejestracja
      </h3>
      <p>
        Zakładając konto, akceptujesz Regulamin. Podanie nieprawdziwych danych
        obciąża Ciebie. WeExpert może poprosić o potwierdzenie danych. Możesz
        wycofać rejestrację i poprosić o usunięcie danych:{" "}
        <a href="mailto:info@weexpert.io" className="text-blue-600 underline">
          info@weexpert.io
        </a>
        . Jako Freelancer możesz mieć tylko jedno konto.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 4 – Ogólne warunki wystawiania Ogłoszeń
      </h3>
      <p>
        Ogłoszenia muszą być zgodne z prawem i Regulaminem oraz nie mogą
        zawierać prywatnych danych kontaktowych Zleceniodawcy ani wezwań do
        wysyłania darmowych próbek. Ogłoszenia są moderowane; mogą zostać
        edytowane lub usunięte, jeśli naruszają przepisy/regulamin.
      </p>
      <p>
        Nie wolno kopiować treści Ogłoszeń do innych serwisów. Freelancer nie
        może składać ofert tylko po to, by „podbijać statystyki”.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Artykuł 5 – Licencje</h3>
      <p>
        Freelancer może udzielić licencji niewyłącznej na korzystanie z
        przedmiotu zlecenia (utrwalanie, kopiowanie, rozpowszechnianie,
        komercjalizacja – zgodnie z pełną wersją Regulaminu).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Artykuł 6 – Opłaty</h3>
      <p>
        Większość funkcji jest bezpłatna. Stała opłata to prowizja serwisu (wg
        Cennika). Usługi dodatkowo płatne obejmują m.in. wystawienie faktury VAT
        bez pro formy, wysyłkę papierowej faktury i korzystanie z szybkich
        płatności online. Szczegóły w Załączniku – Cennik.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 7 – Inne postanowienia
      </h3>
      <p>
        WeExpert nie odpowiada za działania Użytkowników. Możemy usunąć
        Ogłoszenie/Zlecenie i zablokować lub usunąć konto w razie naruszeń
        prawa/Regulaminu/dobrych obyczajów. Blokada usuwa też złożone oferty i
        opublikowane zlecenia.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 8 – Umowy sporne
      </h3>
      <p>
        WeExpert nie odpowiada za niewykonanie/nienależyte wykonanie dzieła
        przez Użytkowników. Wspieramy strony, przedstawiając rekomendowane
        sposoby rozwiązania sporu (opis w pełnym Regulaminie).
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuły 9-10 – Reklamacje i ADR
      </h3>
      <p>
        Reklamacje usług WeExpert:{" "}
        <a href="mailto:info@weexpert.io" className="text-blue-600 underline">
          info@weexpert.io
        </a>{" "}
        (imię i nazwisko, adres korespondencyjny, e-mail konta, telefon, numer
        Ogłoszenia/Zlecenia i materiał do reklamacji). Czas na odpowiedź: do 10
        dni roboczych (z możliwością wydłużenia – informujemy o tym). Możesz
        skorzystać z pozasądowych metod rozwiązywania sporów (ADR) opisanych w
        Regulaminie.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuły 11-12 – Rozwiązanie i odstąpienie
      </h3>
      <p>
        Możesz w każdej chwili rozwiązać umowę z serwisem/odstąpić i skasować
        konto:{" "}
        <a href="mailto:info@weexpert.io" className="text-blue-600 underline">
          info@weexpert.io
        </a>
        . Jeżeli nie było umów – usuwamy konto i dane. Jeżeli były – dane
        przechowujemy przez 5 lat (wymogi prawa). Po usunięciu konta nie
        zalogujesz się dotychczasowymi danymi.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 13 – Zmiany Regulaminu
      </h3>
      <p>
        WeExpert może zmienić Regulamin; poinformujemy o tym w serwisie. Brak
        akceptacji zmian = brak możliwości dalszego korzystania.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 14 – Płatności
      </h3>
      <p>
        Ten punkt wskazuje operatora płatności online, dostępne karty i zasady
        zwrotów/reklamacji transakcji online.
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Artykuł 15 – Postanowienia końcowe
      </h3>
      <p>
        Działamy zgodnie z prawem polskim; spory z umów między Zleceniodawcą a
        Freelancerem rozstrzygają polskie sądy powszechne. Wersja prawnie
        wiążąca: polska (a w razie braku – angielska).
      </p>
      <p className="font-semibold">
        Uwaga: To wersja skrócona – nie stanowi Regulaminu w sensie prawnym.
      </p>
      <p>
        Przejdź do pełnej wersji Regulaminu:{" "}
        <a href="https://weexpert.io" className="text-blue-600 underline">
          weexpert.io
        </a>
      </p>

      <h3 className="text-xl font-semibold mt-10 mb-4">Polityka plików cookies WeExpert</h3>
<p>
  Niniejsza polityka wyjaśnia, jak i po co WeExpert sp. z o.o. korzysta z plików cookie własnych i partnerów oraz podobnych technologii w naszym serwisie. Pokazuje też, jak możesz zarządzać zgodami.
</p>

<h3 className="text-xl font-semibold mt-10 mb-4">1) Czym są pliki cookie?</h3>
<p>
  Cookie to małe pliki zapisywane w Twojej przeglądarce/urządzeniu. Pozwalają naszemu serwisowi rozpoznać Twoje urządzenie i zapamiętać wybrane ustawienia. Zbierane dane (np. adres IP, typ przeglądarki, czas w serwisie, odwiedzane podstrony) co do zasady nie identyfikują Cię bezpośrednio.
</p>

<h3 className="text-xl font-semibold mt-10 mb-4">2) Jakich plików cookie używamy?</h3>
<p>
  W serwisie używamy technologii zapisujących dane na urządzeniu w celach: technicznych, funkcjonalnych, analitycznych, marketingowych/promocyjnych oraz w celach zapewnienia bezpieczeństwa i poprawności działania serwisu. Część to cookies sesyjne (znikają po zamknięciu przeglądarki), część – stałe.
</p>

<h3 className="text-xl font-semibold mt-10 mb-4">3) Czy korzystamy z cookie podmiotów trzecich?</h3>
<p>
  Tak. Współpracujemy z zaufanymi partnerami, którzy mogą umieszczać lub odczytywać cookies, by poprawiać komfort korzystania z serwisu, prowadzić analitykę i marketing oraz zapewniać funkcje produktowe.
</p>
<p>Nasi partnerzy (przykładowo):</p>
<ul className="list-disc pl-5">
  <li>Analityczne: Google (Analytics 4, Tag Manager), Hotjar</li>
  <li>Promocyjne/Reklamowe: Meta (Facebook), LinkedIn, YouTube</li>
  <li>Funkcjonalne/operacyjne: Mailjet, Trustpilot, Bitrix24, SEON, Amazon Web Services, Blue Media, JetBrains, New Relic, Surfer, Brand24</li>
  <li>Nasze centra pomocy/strony produktowe: Help Center WeExpert (odpowiedniki dawnych help/hello)</li>
</ul>
<p>
  Pełne polityki prywatności partnerów znajdziesz na ich stronach. Aktualna lista partnerów i celów jest prezentowana w naszym banerze zgód (CMP) w serwisie.
</p>

<h3 className="text-xl font-semibold mt-10 mb-4">4) Kategorie i cele cookie</h3>
<ul className="list-disc pl-5">
  <li>Techniczne (nie wymagają zgody): niezbędne do działania serwisu (logowanie, bezpieczeństwo, CSRF, konfiguracja sesji, balansowanie ruchu).</li>
  <li>Funkcjonalne (wymagana zgoda): zapamiętywanie preferencji (np. tryb ciemny, język).</li>
  <li>Analityczne (wymagana zgoda): zrozumienie korzystania z serwisu, statystyki, ulepszenia (dane zbierane w formie zanonimizowanej/agg.).</li>
  <li>Marketingowe/Promocyjne (wymagana zgoda): dopasowane treści i pomiar skuteczności kampanii (w serwisie i poza nim).</li>
  <li>Inne/nieklasyfikowane: nowe narzędzia wymagające kategoryzacji.</li>
</ul>
<p>
  Uwaga techniczna: nazwy konkretnych plików (np. _ga, _gid, csrftoken, CookieConsent) i okresy przechowywania mogą się zmieniać wraz z konfiguracją serwisu i partnerów. Aktualny, wiążący wykaz wyświetlamy zawsze w banerze zgód (CMP) i w „Ustawieniach prywatności”.
</p>

<h3 className="text-xl font-semibold mt-10 mb-4">5) Czy cookies przechowują dane osobowe?</h3>
<p>
  Same cookies zwykle nie zawierają danych osobowych. W połączeniu z informacjami z Twojego konta mogą jednak stać się danymi osobowymi. Szczegóły – w naszej <a href="/polityka-prywatnosci">Polityce prywatności</a>.
</p>

<h3 className="text-xl font-semibold mt-10 mb-4">6) Jak korzystamy z cookies?</h3>
<ul className="list-disc pl-5">
  <li>uwierzytelniania/logowania i ułatwienia nawigacji,</li>
  <li>zabezpieczenia serwisu (np. przed atakami botów),</li>
  <li>analityki i statystyk,</li>
  <li>dopasowania treści i komunikatów,</li>
  <li>współpracy z partnerami w zakresie reklamy i pomiaru kampanii.</li>
</ul>

<h3 className="text-xl font-semibold mt-10 mb-4">7) Zarządzanie zgodami / wyłączenie cookies</h3>
<ul className="list-disc pl-5">
  <li>W każdej chwili możesz zarządzać zgodami w naszym banerze zgód (CMP) w serwisie WeExpert (link „Ustawienia prywatności” w stopce).</li>
  <li>Możesz też blokować/usunąć cookies w przeglądarce. Pomoc: Chrome, Firefox, Safari, Edge, Opera itd.</li>
  <li>Na urządzeniach mobilnych skorzystaj z instrukcji producenta.</li>
  <li>Usunięcie cookies nie oznacza usunięcia danych osobowych już przetworzonych – o tym mówi Polityka prywatności.</li>
  <li>Dodatkowo możesz skorzystać z narzędzi branżowych, np. Your Online Choices.</li>
</ul>

<h3 className="text-xl font-semibold mt-10 mb-4">8) Kontakt</h3>
<p>
  Pytania o cookies? Napisz do nas: <a href="mailto:info@weexpert.io">info@weexpert.io</a>.
</p>
    </div>
  );
};
